// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/transportation/reports/noon.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { OffsetDateTime } from "../../../common/date_time/date_time";
import { DateRangeRequest, EmptyRequest, EmptyResponse } from "../../../common/messages/messages";
import { Vessel } from "../vessels/vessel";
import { Voyage } from "../voyages/voyage";

export const protobufPackage = "services.transportation.reports";

export enum BunkerReportPart {
  BUNKER_REPORT_PART_UNSPECIFIED = 0,
  BUNKER_REPORT_PART_MAIN_ENGINE = 1,
  BUNKER_REPORT_PART_POWER_GENERATORS = 2,
  BUNKER_REPORT_PART_BOILERS = 3,
  BUNKER_REPORT_PART_ROBS = 4,
  BUNKER_REPORT_PART_INCINERATOR = 5,
  BUNKER_REPORT_PART_IGG = 6,
  BUNKER_REPORT_PART_NONE = 7,
  UNRECOGNIZED = -1,
}

export function bunkerReportPartFromJSON(object: any): BunkerReportPart {
  switch (object) {
    case 0:
    case "BUNKER_REPORT_PART_UNSPECIFIED":
      return BunkerReportPart.BUNKER_REPORT_PART_UNSPECIFIED;
    case 1:
    case "BUNKER_REPORT_PART_MAIN_ENGINE":
      return BunkerReportPart.BUNKER_REPORT_PART_MAIN_ENGINE;
    case 2:
    case "BUNKER_REPORT_PART_POWER_GENERATORS":
      return BunkerReportPart.BUNKER_REPORT_PART_POWER_GENERATORS;
    case 3:
    case "BUNKER_REPORT_PART_BOILERS":
      return BunkerReportPart.BUNKER_REPORT_PART_BOILERS;
    case 4:
    case "BUNKER_REPORT_PART_ROBS":
      return BunkerReportPart.BUNKER_REPORT_PART_ROBS;
    case 5:
    case "BUNKER_REPORT_PART_INCINERATOR":
      return BunkerReportPart.BUNKER_REPORT_PART_INCINERATOR;
    case 6:
    case "BUNKER_REPORT_PART_IGG":
      return BunkerReportPart.BUNKER_REPORT_PART_IGG;
    case 7:
    case "BUNKER_REPORT_PART_NONE":
      return BunkerReportPart.BUNKER_REPORT_PART_NONE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BunkerReportPart.UNRECOGNIZED;
  }
}

export function bunkerReportPartToJSON(object: BunkerReportPart): string {
  switch (object) {
    case BunkerReportPart.BUNKER_REPORT_PART_UNSPECIFIED:
      return "BUNKER_REPORT_PART_UNSPECIFIED";
    case BunkerReportPart.BUNKER_REPORT_PART_MAIN_ENGINE:
      return "BUNKER_REPORT_PART_MAIN_ENGINE";
    case BunkerReportPart.BUNKER_REPORT_PART_POWER_GENERATORS:
      return "BUNKER_REPORT_PART_POWER_GENERATORS";
    case BunkerReportPart.BUNKER_REPORT_PART_BOILERS:
      return "BUNKER_REPORT_PART_BOILERS";
    case BunkerReportPart.BUNKER_REPORT_PART_ROBS:
      return "BUNKER_REPORT_PART_ROBS";
    case BunkerReportPart.BUNKER_REPORT_PART_INCINERATOR:
      return "BUNKER_REPORT_PART_INCINERATOR";
    case BunkerReportPart.BUNKER_REPORT_PART_IGG:
      return "BUNKER_REPORT_PART_IGG";
    case BunkerReportPart.BUNKER_REPORT_PART_NONE:
      return "BUNKER_REPORT_PART_NONE";
    case BunkerReportPart.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum BunkerType {
  BUNKER_TYPE_UNSPECIFIED = 0,
  BUNKER_TYPE_HFO = 1,
  BUNKER_TYPE_VLSFO = 2,
  BUNKER_TYPE_ULSFO = 3,
  BUNKER_TYPE_MGO = 4,
  BUNKER_TYPE_LSMGO = 5,
  UNRECOGNIZED = -1,
}

export function bunkerTypeFromJSON(object: any): BunkerType {
  switch (object) {
    case 0:
    case "BUNKER_TYPE_UNSPECIFIED":
      return BunkerType.BUNKER_TYPE_UNSPECIFIED;
    case 1:
    case "BUNKER_TYPE_HFO":
      return BunkerType.BUNKER_TYPE_HFO;
    case 2:
    case "BUNKER_TYPE_VLSFO":
      return BunkerType.BUNKER_TYPE_VLSFO;
    case 3:
    case "BUNKER_TYPE_ULSFO":
      return BunkerType.BUNKER_TYPE_ULSFO;
    case 4:
    case "BUNKER_TYPE_MGO":
      return BunkerType.BUNKER_TYPE_MGO;
    case 5:
    case "BUNKER_TYPE_LSMGO":
      return BunkerType.BUNKER_TYPE_LSMGO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return BunkerType.UNRECOGNIZED;
  }
}

export function bunkerTypeToJSON(object: BunkerType): string {
  switch (object) {
    case BunkerType.BUNKER_TYPE_UNSPECIFIED:
      return "BUNKER_TYPE_UNSPECIFIED";
    case BunkerType.BUNKER_TYPE_HFO:
      return "BUNKER_TYPE_HFO";
    case BunkerType.BUNKER_TYPE_VLSFO:
      return "BUNKER_TYPE_VLSFO";
    case BunkerType.BUNKER_TYPE_ULSFO:
      return "BUNKER_TYPE_ULSFO";
    case BunkerType.BUNKER_TYPE_MGO:
      return "BUNKER_TYPE_MGO";
    case BunkerType.BUNKER_TYPE_LSMGO:
      return "BUNKER_TYPE_LSMGO";
    case BunkerType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ManoeuvringStatus {
  MANOEUVRING_STATUS_UNSPECIFIED = 0,
  MANOEUVRING_STATUS_MANOEUVRING = 1,
  MANOEUVRING_STATUS_STEAMING = 2,
  MANOEUVRING_STATUS_DRIFTING = 3,
  UNRECOGNIZED = -1,
}

export function manoeuvringStatusFromJSON(object: any): ManoeuvringStatus {
  switch (object) {
    case 0:
    case "MANOEUVRING_STATUS_UNSPECIFIED":
      return ManoeuvringStatus.MANOEUVRING_STATUS_UNSPECIFIED;
    case 1:
    case "MANOEUVRING_STATUS_MANOEUVRING":
      return ManoeuvringStatus.MANOEUVRING_STATUS_MANOEUVRING;
    case 2:
    case "MANOEUVRING_STATUS_STEAMING":
      return ManoeuvringStatus.MANOEUVRING_STATUS_STEAMING;
    case 3:
    case "MANOEUVRING_STATUS_DRIFTING":
      return ManoeuvringStatus.MANOEUVRING_STATUS_DRIFTING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ManoeuvringStatus.UNRECOGNIZED;
  }
}

export function manoeuvringStatusToJSON(object: ManoeuvringStatus): string {
  switch (object) {
    case ManoeuvringStatus.MANOEUVRING_STATUS_UNSPECIFIED:
      return "MANOEUVRING_STATUS_UNSPECIFIED";
    case ManoeuvringStatus.MANOEUVRING_STATUS_MANOEUVRING:
      return "MANOEUVRING_STATUS_MANOEUVRING";
    case ManoeuvringStatus.MANOEUVRING_STATUS_STEAMING:
      return "MANOEUVRING_STATUS_STEAMING";
    case ManoeuvringStatus.MANOEUVRING_STATUS_DRIFTING:
      return "MANOEUVRING_STATUS_DRIFTING";
    case ManoeuvringStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** SailingStatus enumeration (kept as-is since it's not in the other file) */
export enum SailingStatusv202005 {
  SAILING_STATUS_UNSPECIFIED = 0,
  SAILING_STATUS_LADEN_STEAMING = 1,
  SAILING_STATUS_LADEN_MANEUVERING = 2,
  SAILING_STATUS_BALLAST_STEAMING = 3,
  SAILING_STATUS_BALLAST_MANEUVERING = 4,
  SAILING_STATUS_DRIFTING = 5,
  UNRECOGNIZED = -1,
}

export function sailingStatusv202005FromJSON(object: any): SailingStatusv202005 {
  switch (object) {
    case 0:
    case "SAILING_STATUS_UNSPECIFIED":
      return SailingStatusv202005.SAILING_STATUS_UNSPECIFIED;
    case 1:
    case "SAILING_STATUS_LADEN_STEAMING":
      return SailingStatusv202005.SAILING_STATUS_LADEN_STEAMING;
    case 2:
    case "SAILING_STATUS_LADEN_MANEUVERING":
      return SailingStatusv202005.SAILING_STATUS_LADEN_MANEUVERING;
    case 3:
    case "SAILING_STATUS_BALLAST_STEAMING":
      return SailingStatusv202005.SAILING_STATUS_BALLAST_STEAMING;
    case 4:
    case "SAILING_STATUS_BALLAST_MANEUVERING":
      return SailingStatusv202005.SAILING_STATUS_BALLAST_MANEUVERING;
    case 5:
    case "SAILING_STATUS_DRIFTING":
      return SailingStatusv202005.SAILING_STATUS_DRIFTING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SailingStatusv202005.UNRECOGNIZED;
  }
}

export function sailingStatusv202005ToJSON(object: SailingStatusv202005): string {
  switch (object) {
    case SailingStatusv202005.SAILING_STATUS_UNSPECIFIED:
      return "SAILING_STATUS_UNSPECIFIED";
    case SailingStatusv202005.SAILING_STATUS_LADEN_STEAMING:
      return "SAILING_STATUS_LADEN_STEAMING";
    case SailingStatusv202005.SAILING_STATUS_LADEN_MANEUVERING:
      return "SAILING_STATUS_LADEN_MANEUVERING";
    case SailingStatusv202005.SAILING_STATUS_BALLAST_STEAMING:
      return "SAILING_STATUS_BALLAST_STEAMING";
    case SailingStatusv202005.SAILING_STATUS_BALLAST_MANEUVERING:
      return "SAILING_STATUS_BALLAST_MANEUVERING";
    case SailingStatusv202005.SAILING_STATUS_DRIFTING:
      return "SAILING_STATUS_DRIFTING";
    case SailingStatusv202005.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface UpdateNoonReportV202005Request {
  timestamp: number;
  excelContent: Uint8Array;
}

export interface VesselInfo {
  vesselName: string;
  vesselImo: string;
  master: string;
}

export interface VesselReportDate {
  isoDate: OffsetDateTime | undefined;
}

export interface MovingStatus {
  status: string;
  fromOrganisationId: string;
  toOrganisationId: string;
  eta: OffsetDateTime | undefined;
}

export interface StoppedStatus {
  status: string;
  locationOrganisationId: string;
  atSeaOrAtBerth: string;
  since: OffsetDateTime | undefined;
}

export interface UnknownMovingStatus {
  status: string;
  description: string;
}

export interface VesselReportedDistances {
  distanceCovered: number;
  distanceByMainEngine: number;
  distanceToGo: number;
  totalDistanceRun: number;
}

export interface DMS {
  degree: number;
  minute: number;
  direction: string;
}

export interface GeoCoordinateDMS {
  latitude: DMS | undefined;
  longitude: DMS | undefined;
}

export interface VesselReportedLocation {
  geoCoordinate: GeoCoordinateDMS | undefined;
  bearing: number;
}

export interface VesselReportedSpeed {
  averageCurrentReportSpeed: number;
  averageVoyageSpeed: number;
}

export interface WeatherForce {
  force: number;
  direction: string;
}

export interface VesselReportedWeatherCondition {
  seaForce: WeatherForce | undefined;
  windForce: WeatherForce | undefined;
  currentForce: WeatherForce | undefined;
  swellForce: WeatherForce | undefined;
}

export interface VesselReportedDraft {
  forwardDraft: number;
  middleDraft: number;
  aftDraft: number;
}

export interface VesselReportedTankCondition {
  tankNo: string;
  product: string;
  quantity: number;
  temperature: number;
}

export interface VesselReportedBunker {
  reportPart: BunkerReportPart;
  bunkerType: BunkerType;
  quantityMt: number;
}

export interface VesselReportedMainEngineBunkerConsumption {
  reportPart: BunkerReportPart;
  bunkerType: BunkerType;
  quantityMt: number;
  isLaden?: boolean | undefined;
  manoeuvringStatus?: ManoeuvringStatus | undefined;
  hours?: number | undefined;
  averageRpm?: number | undefined;
}

export interface VesselReportedLubOilStatus {
  mainEngineCylinderOilConsumption: number;
  mainEngineSystemOilConsumption: number;
  auxiliarySystemOilConsumption: number;
  mainEngineCylinderOilRob: number;
  mainEngineSystemOilRob: number;
  auxiliarySystemOilRob: number;
}

export interface VesselReportedFreshWaterStatus {
  rob: number;
  consumption: number;
  generated: number;
}

export interface VesselReportV202205 {
  vesselInfo: VesselInfo | undefined;
  voyageNumber: string;
  reportType: string;
  reportDate: VesselReportDate | undefined;
  currentPlan?: { $case: "movingStatus"; value: MovingStatus } | { $case: "stoppedStatus"; value: StoppedStatus } | {
    $case: "unknownMovingStatus";
    value: UnknownMovingStatus;
  } | undefined;
  distances: VesselReportedDistances | undefined;
  vesselLocation: VesselReportedLocation | undefined;
  speed: VesselReportedSpeed | undefined;
  weatherCondition: VesselReportedWeatherCondition | undefined;
  drafts: VesselReportedDraft | undefined;
  tanksCondition: VesselReportedTankCondition[];
  bunkerReports: VesselReportedMainEngineBunkerConsumption[];
  lubOilStatus: VesselReportedLubOilStatus | undefined;
  freshWaterStatus: VesselReportedFreshWaterStatus | undefined;
  ballastWaterTotalVolume: number;
  comments: string;
  isGasFree?: boolean | undefined;
}

export interface GetVesselReportV202205Response {
  reports: VesselReportV202205[];
}

export interface GetNoonReportV202005Response {
  reports: NoonReportV202005[];
}

/** GeoCoordinateDouble message (assumed to exist or need definition) */
export interface GeoCoordinateDoublev202005 {
  latitude: number;
  longitude: number;
}

/** NoonReportDate */
export interface NoonReportDatev202005 {
  timestamp: number;
  hoursSinceLastReport: number;
  totalSteamingTime: number;
}

/** NoonReportVoyageDetails */
export interface NoonReportVoyageDetailsv202005 {
  voyageNumber: string;
  source: string;
  destination: string;
  isLaden: boolean;
  eta: number;
  distanceCovered: number;
  distanceByMainEngine: number;
  distanceToGo: number;
  totalDistanceRun: number;
}

/** NoonReportPosition */
export interface NoonReportPositionv202005 {
  geoCoordinate: GeoCoordinateDoublev202005 | undefined;
  currentLocation: string;
}

/** NoonReportSpeed */
export interface NoonReportSpeedv202005 {
  speed: number;
  averageSpeed: number;
  mainEngineAverageRpm: number;
}

/** NoonReportCondition */
export interface NoonReportConditionv202005 {
  seaForce: number;
  seaForceDirection: string;
  windForce: number;
  windForceDirection: string;
  currentForce: number;
  currentForceDirection: string;
  forwardDraft: number;
  middleDraft: number;
  aftDraft: number;
}

/** NoonReportTankCondition */
export interface NoonReportTankConditionv202005 {
  tankNo: string;
  product: string;
  quantity: number;
  temperature: number;
}

/** NoonReportBunker */
export interface NoonReportBunkerv202005 {
  bunkerType: string;
  quantityMt: number;
}

/** NoonReportLastReceived */
export interface NoonReportLastReceivedv202005 {
  receivedType: string;
  timestamp: number;
  quantityMt: number;
}

/** NoonReportSailingBunkerConsumption */
export interface NoonReportSailingBunkerConsumptionv202005 {
  status: SailingStatusv202005;
  hours: number;
  averageRpm: number;
  bunkerConsumption: NoonReportBunkerv202005[];
}

/** NoonReportOtherBunkerConsumption */
export interface NoonReportOtherBunkerConsumptionv202005 {
  partName: string;
  bunkerConsumption: NoonReportBunkerv202005[];
}

/** NoonReportBunkerStatus */
export interface NoonReportBunkerStatusv202005 {
  sailingBunkerConsumption: NoonReportSailingBunkerConsumptionv202005[];
  otherBunkerConsumption: NoonReportOtherBunkerConsumptionv202005[];
  rob: NoonReportBunkerv202005[];
  lastReceived: NoonReportLastReceivedv202005[];
}

/** LubOilStatus */
export interface LubOilStatusv202005 {
  mainEngineCylinderOilConsumption: number;
  mainEngineSystemOilConsumption: number;
  auxiliarySystemOilConsumption: number;
  mainEngineCylinderOilRob: number;
  mainEngineSystemOilRob: number;
  auxiliarySystemOilRob: number;
  lastReceived: NoonReportLastReceivedv202005[];
}

/** FreshWaterStatus */
export interface FreshWaterStatusv202005 {
  rob: number;
  consumption: number;
  generated: number;
  lastReceived: NoonReportLastReceivedv202005 | undefined;
}

/** NoonReportV202005 (main report message) */
export interface NoonReportV202005 {
  vesselName: string;
  vesselImo: string;
  date: NoonReportDatev202005 | undefined;
  reportType: string;
  voyageDetails: NoonReportVoyageDetailsv202005 | undefined;
  master: string;
  isDeleted?: boolean | undefined;
  position: NoonReportPositionv202005 | undefined;
  speed: NoonReportSpeedv202005 | undefined;
  condition: NoonReportConditionv202005 | undefined;
  tanksCondition: NoonReportTankConditionv202005[];
  noonReportBunkerStatus: NoonReportBunkerStatusv202005 | undefined;
  lubOilStatus: LubOilStatusv202005 | undefined;
  freshWaterStatus: FreshWaterStatusv202005 | undefined;
  fileId: string;
  comments: string;
}

/** Request message for getting Excel reports */
export interface NoonReportV202005Request {
  startTimestamp: number;
  endTimestamp: number;
}

/** Response message for Excel reports */
export interface NoonReportV202005Response {
  excelFile: Uint8Array;
  fileName: string;
}

export interface LatestReports {
  vessel: Vessel | undefined;
  voyage: Voyage | undefined;
  noonReportV2020: NoonReportV202005 | undefined;
}

export interface GetManagementResponse {
  reports: LatestReports[];
}

function createBaseUpdateNoonReportV202005Request(): UpdateNoonReportV202005Request {
  return { timestamp: 0, excelContent: new Uint8Array(0) };
}

export const UpdateNoonReportV202005Request: MessageFns<UpdateNoonReportV202005Request> = {
  encode(message: UpdateNoonReportV202005Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== 0) {
      writer.uint32(8).int64(message.timestamp);
    }
    if (message.excelContent.length !== 0) {
      writer.uint32(18).bytes(message.excelContent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateNoonReportV202005Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateNoonReportV202005Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.timestamp = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.excelContent = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateNoonReportV202005Request {
    return {
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      excelContent: isSet(object.excelContent)
        ? bytesFromBase64(object.excelContent)
        : isSet(object.excel_content)
        ? bytesFromBase64(object.excel_content)
        : new Uint8Array(0),
    };
  },

  toJSON(message: UpdateNoonReportV202005Request): unknown {
    const obj: any = {};
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.excelContent.length !== 0) {
      obj.excelContent = base64FromBytes(message.excelContent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateNoonReportV202005Request>, I>>(base?: I): UpdateNoonReportV202005Request {
    return UpdateNoonReportV202005Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateNoonReportV202005Request>, I>>(
    object: I,
  ): UpdateNoonReportV202005Request {
    const message = createBaseUpdateNoonReportV202005Request();
    message.timestamp = object.timestamp ?? 0;
    message.excelContent = object.excelContent ?? new Uint8Array(0);
    return message;
  },
};

function createBaseVesselInfo(): VesselInfo {
  return { vesselName: "", vesselImo: "", master: "" };
}

export const VesselInfo: MessageFns<VesselInfo> = {
  encode(message: VesselInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselName !== "") {
      writer.uint32(10).string(message.vesselName);
    }
    if (message.vesselImo !== "") {
      writer.uint32(18).string(message.vesselImo);
    }
    if (message.master !== "") {
      writer.uint32(26).string(message.master);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.master = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselInfo {
    return {
      vesselName: isSet(object.vesselName)
        ? globalThis.String(object.vesselName)
        : isSet(object.vessel_name)
        ? globalThis.String(object.vessel_name)
        : "",
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      master: isSet(object.master) ? globalThis.String(object.master) : "",
    };
  },

  toJSON(message: VesselInfo): unknown {
    const obj: any = {};
    if (message.vesselName !== "") {
      obj.vesselName = message.vesselName;
    }
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.master !== "") {
      obj.master = message.master;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselInfo>, I>>(base?: I): VesselInfo {
    return VesselInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselInfo>, I>>(object: I): VesselInfo {
    const message = createBaseVesselInfo();
    message.vesselName = object.vesselName ?? "";
    message.vesselImo = object.vesselImo ?? "";
    message.master = object.master ?? "";
    return message;
  },
};

function createBaseVesselReportDate(): VesselReportDate {
  return { isoDate: undefined };
}

export const VesselReportDate: MessageFns<VesselReportDate> = {
  encode(message: VesselReportDate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isoDate !== undefined) {
      OffsetDateTime.encode(message.isoDate, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportDate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportDate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.isoDate = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportDate {
    return {
      isoDate: isSet(object.isoDate)
        ? OffsetDateTime.fromJSON(object.isoDate)
        : isSet(object.iso_date)
        ? OffsetDateTime.fromJSON(object.iso_date)
        : undefined,
    };
  },

  toJSON(message: VesselReportDate): unknown {
    const obj: any = {};
    if (message.isoDate !== undefined) {
      obj.isoDate = OffsetDateTime.toJSON(message.isoDate);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportDate>, I>>(base?: I): VesselReportDate {
    return VesselReportDate.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportDate>, I>>(object: I): VesselReportDate {
    const message = createBaseVesselReportDate();
    message.isoDate = (object.isoDate !== undefined && object.isoDate !== null)
      ? OffsetDateTime.fromPartial(object.isoDate)
      : undefined;
    return message;
  },
};

function createBaseMovingStatus(): MovingStatus {
  return { status: "", fromOrganisationId: "", toOrganisationId: "", eta: undefined };
}

export const MovingStatus: MessageFns<MovingStatus> = {
  encode(message: MovingStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.fromOrganisationId !== "") {
      writer.uint32(18).string(message.fromOrganisationId);
    }
    if (message.toOrganisationId !== "") {
      writer.uint32(26).string(message.toOrganisationId);
    }
    if (message.eta !== undefined) {
      OffsetDateTime.encode(message.eta, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MovingStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMovingStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fromOrganisationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.toOrganisationId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.eta = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MovingStatus {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      fromOrganisationId: isSet(object.fromOrganisationId)
        ? globalThis.String(object.fromOrganisationId)
        : isSet(object.from_organisation_id)
        ? globalThis.String(object.from_organisation_id)
        : "",
      toOrganisationId: isSet(object.toOrganisationId)
        ? globalThis.String(object.toOrganisationId)
        : isSet(object.to_organisation_id)
        ? globalThis.String(object.to_organisation_id)
        : "",
      eta: isSet(object.eta) ? OffsetDateTime.fromJSON(object.eta) : undefined,
    };
  },

  toJSON(message: MovingStatus): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.fromOrganisationId !== "") {
      obj.fromOrganisationId = message.fromOrganisationId;
    }
    if (message.toOrganisationId !== "") {
      obj.toOrganisationId = message.toOrganisationId;
    }
    if (message.eta !== undefined) {
      obj.eta = OffsetDateTime.toJSON(message.eta);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MovingStatus>, I>>(base?: I): MovingStatus {
    return MovingStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MovingStatus>, I>>(object: I): MovingStatus {
    const message = createBaseMovingStatus();
    message.status = object.status ?? "";
    message.fromOrganisationId = object.fromOrganisationId ?? "";
    message.toOrganisationId = object.toOrganisationId ?? "";
    message.eta = (object.eta !== undefined && object.eta !== null)
      ? OffsetDateTime.fromPartial(object.eta)
      : undefined;
    return message;
  },
};

function createBaseStoppedStatus(): StoppedStatus {
  return { status: "", locationOrganisationId: "", atSeaOrAtBerth: "", since: undefined };
}

export const StoppedStatus: MessageFns<StoppedStatus> = {
  encode(message: StoppedStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.locationOrganisationId !== "") {
      writer.uint32(18).string(message.locationOrganisationId);
    }
    if (message.atSeaOrAtBerth !== "") {
      writer.uint32(26).string(message.atSeaOrAtBerth);
    }
    if (message.since !== undefined) {
      OffsetDateTime.encode(message.since, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StoppedStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStoppedStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.locationOrganisationId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.atSeaOrAtBerth = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.since = OffsetDateTime.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StoppedStatus {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      locationOrganisationId: isSet(object.locationOrganisationId)
        ? globalThis.String(object.locationOrganisationId)
        : isSet(object.location_organisation_id)
        ? globalThis.String(object.location_organisation_id)
        : "",
      atSeaOrAtBerth: isSet(object.atSeaOrAtBerth)
        ? globalThis.String(object.atSeaOrAtBerth)
        : isSet(object.at_sea_or_at_berth)
        ? globalThis.String(object.at_sea_or_at_berth)
        : "",
      since: isSet(object.since) ? OffsetDateTime.fromJSON(object.since) : undefined,
    };
  },

  toJSON(message: StoppedStatus): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.locationOrganisationId !== "") {
      obj.locationOrganisationId = message.locationOrganisationId;
    }
    if (message.atSeaOrAtBerth !== "") {
      obj.atSeaOrAtBerth = message.atSeaOrAtBerth;
    }
    if (message.since !== undefined) {
      obj.since = OffsetDateTime.toJSON(message.since);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StoppedStatus>, I>>(base?: I): StoppedStatus {
    return StoppedStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StoppedStatus>, I>>(object: I): StoppedStatus {
    const message = createBaseStoppedStatus();
    message.status = object.status ?? "";
    message.locationOrganisationId = object.locationOrganisationId ?? "";
    message.atSeaOrAtBerth = object.atSeaOrAtBerth ?? "";
    message.since = (object.since !== undefined && object.since !== null)
      ? OffsetDateTime.fromPartial(object.since)
      : undefined;
    return message;
  },
};

function createBaseUnknownMovingStatus(): UnknownMovingStatus {
  return { status: "", description: "" };
}

export const UnknownMovingStatus: MessageFns<UnknownMovingStatus> = {
  encode(message: UnknownMovingStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnknownMovingStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnknownMovingStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnknownMovingStatus {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: UnknownMovingStatus): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UnknownMovingStatus>, I>>(base?: I): UnknownMovingStatus {
    return UnknownMovingStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UnknownMovingStatus>, I>>(object: I): UnknownMovingStatus {
    const message = createBaseUnknownMovingStatus();
    message.status = object.status ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseVesselReportedDistances(): VesselReportedDistances {
  return { distanceCovered: 0, distanceByMainEngine: 0, distanceToGo: 0, totalDistanceRun: 0 };
}

export const VesselReportedDistances: MessageFns<VesselReportedDistances> = {
  encode(message: VesselReportedDistances, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.distanceCovered !== 0) {
      writer.uint32(9).double(message.distanceCovered);
    }
    if (message.distanceByMainEngine !== 0) {
      writer.uint32(17).double(message.distanceByMainEngine);
    }
    if (message.distanceToGo !== 0) {
      writer.uint32(25).double(message.distanceToGo);
    }
    if (message.totalDistanceRun !== 0) {
      writer.uint32(33).double(message.totalDistanceRun);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportedDistances {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportedDistances();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.distanceCovered = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.distanceByMainEngine = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.distanceToGo = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.totalDistanceRun = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportedDistances {
    return {
      distanceCovered: isSet(object.distanceCovered)
        ? globalThis.Number(object.distanceCovered)
        : isSet(object.distance_covered)
        ? globalThis.Number(object.distance_covered)
        : 0,
      distanceByMainEngine: isSet(object.distanceByMainEngine)
        ? globalThis.Number(object.distanceByMainEngine)
        : isSet(object.distance_by_main_engine)
        ? globalThis.Number(object.distance_by_main_engine)
        : 0,
      distanceToGo: isSet(object.distanceToGo)
        ? globalThis.Number(object.distanceToGo)
        : isSet(object.distance_to_go)
        ? globalThis.Number(object.distance_to_go)
        : 0,
      totalDistanceRun: isSet(object.totalDistanceRun)
        ? globalThis.Number(object.totalDistanceRun)
        : isSet(object.total_distance_run)
        ? globalThis.Number(object.total_distance_run)
        : 0,
    };
  },

  toJSON(message: VesselReportedDistances): unknown {
    const obj: any = {};
    if (message.distanceCovered !== 0) {
      obj.distanceCovered = message.distanceCovered;
    }
    if (message.distanceByMainEngine !== 0) {
      obj.distanceByMainEngine = message.distanceByMainEngine;
    }
    if (message.distanceToGo !== 0) {
      obj.distanceToGo = message.distanceToGo;
    }
    if (message.totalDistanceRun !== 0) {
      obj.totalDistanceRun = message.totalDistanceRun;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportedDistances>, I>>(base?: I): VesselReportedDistances {
    return VesselReportedDistances.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportedDistances>, I>>(object: I): VesselReportedDistances {
    const message = createBaseVesselReportedDistances();
    message.distanceCovered = object.distanceCovered ?? 0;
    message.distanceByMainEngine = object.distanceByMainEngine ?? 0;
    message.distanceToGo = object.distanceToGo ?? 0;
    message.totalDistanceRun = object.totalDistanceRun ?? 0;
    return message;
  },
};

function createBaseDMS(): DMS {
  return { degree: 0, minute: 0, direction: "" };
}

export const DMS: MessageFns<DMS> = {
  encode(message: DMS, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.degree !== 0) {
      writer.uint32(9).double(message.degree);
    }
    if (message.minute !== 0) {
      writer.uint32(17).double(message.minute);
    }
    if (message.direction !== "") {
      writer.uint32(26).string(message.direction);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DMS {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDMS();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.degree = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.minute = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.direction = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DMS {
    return {
      degree: isSet(object.degree) ? globalThis.Number(object.degree) : 0,
      minute: isSet(object.minute) ? globalThis.Number(object.minute) : 0,
      direction: isSet(object.direction) ? globalThis.String(object.direction) : "",
    };
  },

  toJSON(message: DMS): unknown {
    const obj: any = {};
    if (message.degree !== 0) {
      obj.degree = message.degree;
    }
    if (message.minute !== 0) {
      obj.minute = message.minute;
    }
    if (message.direction !== "") {
      obj.direction = message.direction;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DMS>, I>>(base?: I): DMS {
    return DMS.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DMS>, I>>(object: I): DMS {
    const message = createBaseDMS();
    message.degree = object.degree ?? 0;
    message.minute = object.minute ?? 0;
    message.direction = object.direction ?? "";
    return message;
  },
};

function createBaseGeoCoordinateDMS(): GeoCoordinateDMS {
  return { latitude: undefined, longitude: undefined };
}

export const GeoCoordinateDMS: MessageFns<GeoCoordinateDMS> = {
  encode(message: GeoCoordinateDMS, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latitude !== undefined) {
      DMS.encode(message.latitude, writer.uint32(10).fork()).join();
    }
    if (message.longitude !== undefined) {
      DMS.encode(message.longitude, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GeoCoordinateDMS {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeoCoordinateDMS();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.latitude = DMS.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.longitude = DMS.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GeoCoordinateDMS {
    return {
      latitude: isSet(object.latitude) ? DMS.fromJSON(object.latitude) : undefined,
      longitude: isSet(object.longitude) ? DMS.fromJSON(object.longitude) : undefined,
    };
  },

  toJSON(message: GeoCoordinateDMS): unknown {
    const obj: any = {};
    if (message.latitude !== undefined) {
      obj.latitude = DMS.toJSON(message.latitude);
    }
    if (message.longitude !== undefined) {
      obj.longitude = DMS.toJSON(message.longitude);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GeoCoordinateDMS>, I>>(base?: I): GeoCoordinateDMS {
    return GeoCoordinateDMS.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GeoCoordinateDMS>, I>>(object: I): GeoCoordinateDMS {
    const message = createBaseGeoCoordinateDMS();
    message.latitude = (object.latitude !== undefined && object.latitude !== null)
      ? DMS.fromPartial(object.latitude)
      : undefined;
    message.longitude = (object.longitude !== undefined && object.longitude !== null)
      ? DMS.fromPartial(object.longitude)
      : undefined;
    return message;
  },
};

function createBaseVesselReportedLocation(): VesselReportedLocation {
  return { geoCoordinate: undefined, bearing: 0 };
}

export const VesselReportedLocation: MessageFns<VesselReportedLocation> = {
  encode(message: VesselReportedLocation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.geoCoordinate !== undefined) {
      GeoCoordinateDMS.encode(message.geoCoordinate, writer.uint32(10).fork()).join();
    }
    if (message.bearing !== 0) {
      writer.uint32(17).double(message.bearing);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportedLocation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportedLocation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.geoCoordinate = GeoCoordinateDMS.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.bearing = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportedLocation {
    return {
      geoCoordinate: isSet(object.geoCoordinate)
        ? GeoCoordinateDMS.fromJSON(object.geoCoordinate)
        : isSet(object.geo_coordinate)
        ? GeoCoordinateDMS.fromJSON(object.geo_coordinate)
        : undefined,
      bearing: isSet(object.bearing) ? globalThis.Number(object.bearing) : 0,
    };
  },

  toJSON(message: VesselReportedLocation): unknown {
    const obj: any = {};
    if (message.geoCoordinate !== undefined) {
      obj.geoCoordinate = GeoCoordinateDMS.toJSON(message.geoCoordinate);
    }
    if (message.bearing !== 0) {
      obj.bearing = message.bearing;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportedLocation>, I>>(base?: I): VesselReportedLocation {
    return VesselReportedLocation.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportedLocation>, I>>(object: I): VesselReportedLocation {
    const message = createBaseVesselReportedLocation();
    message.geoCoordinate = (object.geoCoordinate !== undefined && object.geoCoordinate !== null)
      ? GeoCoordinateDMS.fromPartial(object.geoCoordinate)
      : undefined;
    message.bearing = object.bearing ?? 0;
    return message;
  },
};

function createBaseVesselReportedSpeed(): VesselReportedSpeed {
  return { averageCurrentReportSpeed: 0, averageVoyageSpeed: 0 };
}

export const VesselReportedSpeed: MessageFns<VesselReportedSpeed> = {
  encode(message: VesselReportedSpeed, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.averageCurrentReportSpeed !== 0) {
      writer.uint32(9).double(message.averageCurrentReportSpeed);
    }
    if (message.averageVoyageSpeed !== 0) {
      writer.uint32(17).double(message.averageVoyageSpeed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportedSpeed {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportedSpeed();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.averageCurrentReportSpeed = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.averageVoyageSpeed = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportedSpeed {
    return {
      averageCurrentReportSpeed: isSet(object.averageCurrentReportSpeed)
        ? globalThis.Number(object.averageCurrentReportSpeed)
        : isSet(object.average_current_report_speed)
        ? globalThis.Number(object.average_current_report_speed)
        : 0,
      averageVoyageSpeed: isSet(object.averageVoyageSpeed)
        ? globalThis.Number(object.averageVoyageSpeed)
        : isSet(object.average_voyage_speed)
        ? globalThis.Number(object.average_voyage_speed)
        : 0,
    };
  },

  toJSON(message: VesselReportedSpeed): unknown {
    const obj: any = {};
    if (message.averageCurrentReportSpeed !== 0) {
      obj.averageCurrentReportSpeed = message.averageCurrentReportSpeed;
    }
    if (message.averageVoyageSpeed !== 0) {
      obj.averageVoyageSpeed = message.averageVoyageSpeed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportedSpeed>, I>>(base?: I): VesselReportedSpeed {
    return VesselReportedSpeed.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportedSpeed>, I>>(object: I): VesselReportedSpeed {
    const message = createBaseVesselReportedSpeed();
    message.averageCurrentReportSpeed = object.averageCurrentReportSpeed ?? 0;
    message.averageVoyageSpeed = object.averageVoyageSpeed ?? 0;
    return message;
  },
};

function createBaseWeatherForce(): WeatherForce {
  return { force: 0, direction: "" };
}

export const WeatherForce: MessageFns<WeatherForce> = {
  encode(message: WeatherForce, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.force !== 0) {
      writer.uint32(9).double(message.force);
    }
    if (message.direction !== "") {
      writer.uint32(18).string(message.direction);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WeatherForce {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWeatherForce();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.force = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.direction = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WeatherForce {
    return {
      force: isSet(object.force) ? globalThis.Number(object.force) : 0,
      direction: isSet(object.direction) ? globalThis.String(object.direction) : "",
    };
  },

  toJSON(message: WeatherForce): unknown {
    const obj: any = {};
    if (message.force !== 0) {
      obj.force = message.force;
    }
    if (message.direction !== "") {
      obj.direction = message.direction;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WeatherForce>, I>>(base?: I): WeatherForce {
    return WeatherForce.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WeatherForce>, I>>(object: I): WeatherForce {
    const message = createBaseWeatherForce();
    message.force = object.force ?? 0;
    message.direction = object.direction ?? "";
    return message;
  },
};

function createBaseVesselReportedWeatherCondition(): VesselReportedWeatherCondition {
  return { seaForce: undefined, windForce: undefined, currentForce: undefined, swellForce: undefined };
}

export const VesselReportedWeatherCondition: MessageFns<VesselReportedWeatherCondition> = {
  encode(message: VesselReportedWeatherCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seaForce !== undefined) {
      WeatherForce.encode(message.seaForce, writer.uint32(10).fork()).join();
    }
    if (message.windForce !== undefined) {
      WeatherForce.encode(message.windForce, writer.uint32(18).fork()).join();
    }
    if (message.currentForce !== undefined) {
      WeatherForce.encode(message.currentForce, writer.uint32(26).fork()).join();
    }
    if (message.swellForce !== undefined) {
      WeatherForce.encode(message.swellForce, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportedWeatherCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportedWeatherCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.seaForce = WeatherForce.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.windForce = WeatherForce.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.currentForce = WeatherForce.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.swellForce = WeatherForce.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportedWeatherCondition {
    return {
      seaForce: isSet(object.seaForce)
        ? WeatherForce.fromJSON(object.seaForce)
        : isSet(object.sea_force)
        ? WeatherForce.fromJSON(object.sea_force)
        : undefined,
      windForce: isSet(object.windForce)
        ? WeatherForce.fromJSON(object.windForce)
        : isSet(object.wind_force)
        ? WeatherForce.fromJSON(object.wind_force)
        : undefined,
      currentForce: isSet(object.currentForce)
        ? WeatherForce.fromJSON(object.currentForce)
        : isSet(object.current_force)
        ? WeatherForce.fromJSON(object.current_force)
        : undefined,
      swellForce: isSet(object.swellForce)
        ? WeatherForce.fromJSON(object.swellForce)
        : isSet(object.swell_force)
        ? WeatherForce.fromJSON(object.swell_force)
        : undefined,
    };
  },

  toJSON(message: VesselReportedWeatherCondition): unknown {
    const obj: any = {};
    if (message.seaForce !== undefined) {
      obj.seaForce = WeatherForce.toJSON(message.seaForce);
    }
    if (message.windForce !== undefined) {
      obj.windForce = WeatherForce.toJSON(message.windForce);
    }
    if (message.currentForce !== undefined) {
      obj.currentForce = WeatherForce.toJSON(message.currentForce);
    }
    if (message.swellForce !== undefined) {
      obj.swellForce = WeatherForce.toJSON(message.swellForce);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportedWeatherCondition>, I>>(base?: I): VesselReportedWeatherCondition {
    return VesselReportedWeatherCondition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportedWeatherCondition>, I>>(
    object: I,
  ): VesselReportedWeatherCondition {
    const message = createBaseVesselReportedWeatherCondition();
    message.seaForce = (object.seaForce !== undefined && object.seaForce !== null)
      ? WeatherForce.fromPartial(object.seaForce)
      : undefined;
    message.windForce = (object.windForce !== undefined && object.windForce !== null)
      ? WeatherForce.fromPartial(object.windForce)
      : undefined;
    message.currentForce = (object.currentForce !== undefined && object.currentForce !== null)
      ? WeatherForce.fromPartial(object.currentForce)
      : undefined;
    message.swellForce = (object.swellForce !== undefined && object.swellForce !== null)
      ? WeatherForce.fromPartial(object.swellForce)
      : undefined;
    return message;
  },
};

function createBaseVesselReportedDraft(): VesselReportedDraft {
  return { forwardDraft: 0, middleDraft: 0, aftDraft: 0 };
}

export const VesselReportedDraft: MessageFns<VesselReportedDraft> = {
  encode(message: VesselReportedDraft, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.forwardDraft !== 0) {
      writer.uint32(9).double(message.forwardDraft);
    }
    if (message.middleDraft !== 0) {
      writer.uint32(17).double(message.middleDraft);
    }
    if (message.aftDraft !== 0) {
      writer.uint32(25).double(message.aftDraft);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportedDraft {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportedDraft();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.forwardDraft = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.middleDraft = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.aftDraft = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportedDraft {
    return {
      forwardDraft: isSet(object.forwardDraft)
        ? globalThis.Number(object.forwardDraft)
        : isSet(object.forward_draft)
        ? globalThis.Number(object.forward_draft)
        : 0,
      middleDraft: isSet(object.middleDraft)
        ? globalThis.Number(object.middleDraft)
        : isSet(object.middle_draft)
        ? globalThis.Number(object.middle_draft)
        : 0,
      aftDraft: isSet(object.aftDraft)
        ? globalThis.Number(object.aftDraft)
        : isSet(object.aft_draft)
        ? globalThis.Number(object.aft_draft)
        : 0,
    };
  },

  toJSON(message: VesselReportedDraft): unknown {
    const obj: any = {};
    if (message.forwardDraft !== 0) {
      obj.forwardDraft = message.forwardDraft;
    }
    if (message.middleDraft !== 0) {
      obj.middleDraft = message.middleDraft;
    }
    if (message.aftDraft !== 0) {
      obj.aftDraft = message.aftDraft;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportedDraft>, I>>(base?: I): VesselReportedDraft {
    return VesselReportedDraft.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportedDraft>, I>>(object: I): VesselReportedDraft {
    const message = createBaseVesselReportedDraft();
    message.forwardDraft = object.forwardDraft ?? 0;
    message.middleDraft = object.middleDraft ?? 0;
    message.aftDraft = object.aftDraft ?? 0;
    return message;
  },
};

function createBaseVesselReportedTankCondition(): VesselReportedTankCondition {
  return { tankNo: "", product: "", quantity: 0, temperature: 0 };
}

export const VesselReportedTankCondition: MessageFns<VesselReportedTankCondition> = {
  encode(message: VesselReportedTankCondition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tankNo !== "") {
      writer.uint32(10).string(message.tankNo);
    }
    if (message.product !== "") {
      writer.uint32(18).string(message.product);
    }
    if (message.quantity !== 0) {
      writer.uint32(25).double(message.quantity);
    }
    if (message.temperature !== 0) {
      writer.uint32(33).double(message.temperature);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportedTankCondition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportedTankCondition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tankNo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.quantity = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.temperature = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportedTankCondition {
    return {
      tankNo: isSet(object.tankNo)
        ? globalThis.String(object.tankNo)
        : isSet(object.tank_no)
        ? globalThis.String(object.tank_no)
        : "",
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : 0,
    };
  },

  toJSON(message: VesselReportedTankCondition): unknown {
    const obj: any = {};
    if (message.tankNo !== "") {
      obj.tankNo = message.tankNo;
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.quantity !== 0) {
      obj.quantity = message.quantity;
    }
    if (message.temperature !== 0) {
      obj.temperature = message.temperature;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportedTankCondition>, I>>(base?: I): VesselReportedTankCondition {
    return VesselReportedTankCondition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportedTankCondition>, I>>(object: I): VesselReportedTankCondition {
    const message = createBaseVesselReportedTankCondition();
    message.tankNo = object.tankNo ?? "";
    message.product = object.product ?? "";
    message.quantity = object.quantity ?? 0;
    message.temperature = object.temperature ?? 0;
    return message;
  },
};

function createBaseVesselReportedBunker(): VesselReportedBunker {
  return { reportPart: 0, bunkerType: 0, quantityMt: 0 };
}

export const VesselReportedBunker: MessageFns<VesselReportedBunker> = {
  encode(message: VesselReportedBunker, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reportPart !== 0) {
      writer.uint32(8).int32(message.reportPart);
    }
    if (message.bunkerType !== 0) {
      writer.uint32(16).int32(message.bunkerType);
    }
    if (message.quantityMt !== 0) {
      writer.uint32(25).double(message.quantityMt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportedBunker {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportedBunker();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.reportPart = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.bunkerType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.quantityMt = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportedBunker {
    return {
      reportPart: isSet(object.reportPart)
        ? bunkerReportPartFromJSON(object.reportPart)
        : isSet(object.report_part)
        ? bunkerReportPartFromJSON(object.report_part)
        : 0,
      bunkerType: isSet(object.bunkerType)
        ? bunkerTypeFromJSON(object.bunkerType)
        : isSet(object.bunker_type)
        ? bunkerTypeFromJSON(object.bunker_type)
        : 0,
      quantityMt: isSet(object.quantityMt)
        ? globalThis.Number(object.quantityMt)
        : isSet(object.quantity_mt)
        ? globalThis.Number(object.quantity_mt)
        : 0,
    };
  },

  toJSON(message: VesselReportedBunker): unknown {
    const obj: any = {};
    if (message.reportPart !== 0) {
      obj.reportPart = bunkerReportPartToJSON(message.reportPart);
    }
    if (message.bunkerType !== 0) {
      obj.bunkerType = bunkerTypeToJSON(message.bunkerType);
    }
    if (message.quantityMt !== 0) {
      obj.quantityMt = message.quantityMt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportedBunker>, I>>(base?: I): VesselReportedBunker {
    return VesselReportedBunker.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportedBunker>, I>>(object: I): VesselReportedBunker {
    const message = createBaseVesselReportedBunker();
    message.reportPart = object.reportPart ?? 0;
    message.bunkerType = object.bunkerType ?? 0;
    message.quantityMt = object.quantityMt ?? 0;
    return message;
  },
};

function createBaseVesselReportedMainEngineBunkerConsumption(): VesselReportedMainEngineBunkerConsumption {
  return {
    reportPart: 0,
    bunkerType: 0,
    quantityMt: 0,
    isLaden: undefined,
    manoeuvringStatus: undefined,
    hours: undefined,
    averageRpm: undefined,
  };
}

export const VesselReportedMainEngineBunkerConsumption: MessageFns<VesselReportedMainEngineBunkerConsumption> = {
  encode(message: VesselReportedMainEngineBunkerConsumption, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reportPart !== 0) {
      writer.uint32(8).int32(message.reportPart);
    }
    if (message.bunkerType !== 0) {
      writer.uint32(16).int32(message.bunkerType);
    }
    if (message.quantityMt !== 0) {
      writer.uint32(25).double(message.quantityMt);
    }
    if (message.isLaden !== undefined) {
      writer.uint32(32).bool(message.isLaden);
    }
    if (message.manoeuvringStatus !== undefined) {
      writer.uint32(40).int32(message.manoeuvringStatus);
    }
    if (message.hours !== undefined) {
      writer.uint32(49).double(message.hours);
    }
    if (message.averageRpm !== undefined) {
      writer.uint32(57).double(message.averageRpm);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportedMainEngineBunkerConsumption {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportedMainEngineBunkerConsumption();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.reportPart = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.bunkerType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.quantityMt = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isLaden = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.manoeuvringStatus = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.hours = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.averageRpm = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportedMainEngineBunkerConsumption {
    return {
      reportPart: isSet(object.reportPart)
        ? bunkerReportPartFromJSON(object.reportPart)
        : isSet(object.report_part)
        ? bunkerReportPartFromJSON(object.report_part)
        : 0,
      bunkerType: isSet(object.bunkerType)
        ? bunkerTypeFromJSON(object.bunkerType)
        : isSet(object.bunker_type)
        ? bunkerTypeFromJSON(object.bunker_type)
        : 0,
      quantityMt: isSet(object.quantityMt)
        ? globalThis.Number(object.quantityMt)
        : isSet(object.quantity_mt)
        ? globalThis.Number(object.quantity_mt)
        : 0,
      isLaden: isSet(object.isLaden)
        ? globalThis.Boolean(object.isLaden)
        : isSet(object.is_laden)
        ? globalThis.Boolean(object.is_laden)
        : undefined,
      manoeuvringStatus: isSet(object.manoeuvringStatus)
        ? manoeuvringStatusFromJSON(object.manoeuvringStatus)
        : isSet(object.manoeuvring_status)
        ? manoeuvringStatusFromJSON(object.manoeuvring_status)
        : undefined,
      hours: isSet(object.hours) ? globalThis.Number(object.hours) : undefined,
      averageRpm: isSet(object.averageRpm)
        ? globalThis.Number(object.averageRpm)
        : isSet(object.average_rpm)
        ? globalThis.Number(object.average_rpm)
        : undefined,
    };
  },

  toJSON(message: VesselReportedMainEngineBunkerConsumption): unknown {
    const obj: any = {};
    if (message.reportPart !== 0) {
      obj.reportPart = bunkerReportPartToJSON(message.reportPart);
    }
    if (message.bunkerType !== 0) {
      obj.bunkerType = bunkerTypeToJSON(message.bunkerType);
    }
    if (message.quantityMt !== 0) {
      obj.quantityMt = message.quantityMt;
    }
    if (message.isLaden !== undefined) {
      obj.isLaden = message.isLaden;
    }
    if (message.manoeuvringStatus !== undefined) {
      obj.manoeuvringStatus = manoeuvringStatusToJSON(message.manoeuvringStatus);
    }
    if (message.hours !== undefined) {
      obj.hours = message.hours;
    }
    if (message.averageRpm !== undefined) {
      obj.averageRpm = message.averageRpm;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportedMainEngineBunkerConsumption>, I>>(
    base?: I,
  ): VesselReportedMainEngineBunkerConsumption {
    return VesselReportedMainEngineBunkerConsumption.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportedMainEngineBunkerConsumption>, I>>(
    object: I,
  ): VesselReportedMainEngineBunkerConsumption {
    const message = createBaseVesselReportedMainEngineBunkerConsumption();
    message.reportPart = object.reportPart ?? 0;
    message.bunkerType = object.bunkerType ?? 0;
    message.quantityMt = object.quantityMt ?? 0;
    message.isLaden = object.isLaden ?? undefined;
    message.manoeuvringStatus = object.manoeuvringStatus ?? undefined;
    message.hours = object.hours ?? undefined;
    message.averageRpm = object.averageRpm ?? undefined;
    return message;
  },
};

function createBaseVesselReportedLubOilStatus(): VesselReportedLubOilStatus {
  return {
    mainEngineCylinderOilConsumption: 0,
    mainEngineSystemOilConsumption: 0,
    auxiliarySystemOilConsumption: 0,
    mainEngineCylinderOilRob: 0,
    mainEngineSystemOilRob: 0,
    auxiliarySystemOilRob: 0,
  };
}

export const VesselReportedLubOilStatus: MessageFns<VesselReportedLubOilStatus> = {
  encode(message: VesselReportedLubOilStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mainEngineCylinderOilConsumption !== 0) {
      writer.uint32(9).double(message.mainEngineCylinderOilConsumption);
    }
    if (message.mainEngineSystemOilConsumption !== 0) {
      writer.uint32(17).double(message.mainEngineSystemOilConsumption);
    }
    if (message.auxiliarySystemOilConsumption !== 0) {
      writer.uint32(25).double(message.auxiliarySystemOilConsumption);
    }
    if (message.mainEngineCylinderOilRob !== 0) {
      writer.uint32(33).double(message.mainEngineCylinderOilRob);
    }
    if (message.mainEngineSystemOilRob !== 0) {
      writer.uint32(41).double(message.mainEngineSystemOilRob);
    }
    if (message.auxiliarySystemOilRob !== 0) {
      writer.uint32(49).double(message.auxiliarySystemOilRob);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportedLubOilStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportedLubOilStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.mainEngineCylinderOilConsumption = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.mainEngineSystemOilConsumption = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.auxiliarySystemOilConsumption = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.mainEngineCylinderOilRob = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.mainEngineSystemOilRob = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.auxiliarySystemOilRob = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportedLubOilStatus {
    return {
      mainEngineCylinderOilConsumption: isSet(object.mainEngineCylinderOilConsumption)
        ? globalThis.Number(object.mainEngineCylinderOilConsumption)
        : isSet(object.main_engine_cylinder_oil_consumption)
        ? globalThis.Number(object.main_engine_cylinder_oil_consumption)
        : 0,
      mainEngineSystemOilConsumption: isSet(object.mainEngineSystemOilConsumption)
        ? globalThis.Number(object.mainEngineSystemOilConsumption)
        : isSet(object.main_engine_system_oil_consumption)
        ? globalThis.Number(object.main_engine_system_oil_consumption)
        : 0,
      auxiliarySystemOilConsumption: isSet(object.auxiliarySystemOilConsumption)
        ? globalThis.Number(object.auxiliarySystemOilConsumption)
        : isSet(object.auxiliary_system_oil_consumption)
        ? globalThis.Number(object.auxiliary_system_oil_consumption)
        : 0,
      mainEngineCylinderOilRob: isSet(object.mainEngineCylinderOilRob)
        ? globalThis.Number(object.mainEngineCylinderOilRob)
        : isSet(object.main_engine_cylinder_oil_rob)
        ? globalThis.Number(object.main_engine_cylinder_oil_rob)
        : 0,
      mainEngineSystemOilRob: isSet(object.mainEngineSystemOilRob)
        ? globalThis.Number(object.mainEngineSystemOilRob)
        : isSet(object.main_engine_system_oil_rob)
        ? globalThis.Number(object.main_engine_system_oil_rob)
        : 0,
      auxiliarySystemOilRob: isSet(object.auxiliarySystemOilRob)
        ? globalThis.Number(object.auxiliarySystemOilRob)
        : isSet(object.auxiliary_system_oil_rob)
        ? globalThis.Number(object.auxiliary_system_oil_rob)
        : 0,
    };
  },

  toJSON(message: VesselReportedLubOilStatus): unknown {
    const obj: any = {};
    if (message.mainEngineCylinderOilConsumption !== 0) {
      obj.mainEngineCylinderOilConsumption = message.mainEngineCylinderOilConsumption;
    }
    if (message.mainEngineSystemOilConsumption !== 0) {
      obj.mainEngineSystemOilConsumption = message.mainEngineSystemOilConsumption;
    }
    if (message.auxiliarySystemOilConsumption !== 0) {
      obj.auxiliarySystemOilConsumption = message.auxiliarySystemOilConsumption;
    }
    if (message.mainEngineCylinderOilRob !== 0) {
      obj.mainEngineCylinderOilRob = message.mainEngineCylinderOilRob;
    }
    if (message.mainEngineSystemOilRob !== 0) {
      obj.mainEngineSystemOilRob = message.mainEngineSystemOilRob;
    }
    if (message.auxiliarySystemOilRob !== 0) {
      obj.auxiliarySystemOilRob = message.auxiliarySystemOilRob;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportedLubOilStatus>, I>>(base?: I): VesselReportedLubOilStatus {
    return VesselReportedLubOilStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportedLubOilStatus>, I>>(object: I): VesselReportedLubOilStatus {
    const message = createBaseVesselReportedLubOilStatus();
    message.mainEngineCylinderOilConsumption = object.mainEngineCylinderOilConsumption ?? 0;
    message.mainEngineSystemOilConsumption = object.mainEngineSystemOilConsumption ?? 0;
    message.auxiliarySystemOilConsumption = object.auxiliarySystemOilConsumption ?? 0;
    message.mainEngineCylinderOilRob = object.mainEngineCylinderOilRob ?? 0;
    message.mainEngineSystemOilRob = object.mainEngineSystemOilRob ?? 0;
    message.auxiliarySystemOilRob = object.auxiliarySystemOilRob ?? 0;
    return message;
  },
};

function createBaseVesselReportedFreshWaterStatus(): VesselReportedFreshWaterStatus {
  return { rob: 0, consumption: 0, generated: 0 };
}

export const VesselReportedFreshWaterStatus: MessageFns<VesselReportedFreshWaterStatus> = {
  encode(message: VesselReportedFreshWaterStatus, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rob !== 0) {
      writer.uint32(9).double(message.rob);
    }
    if (message.consumption !== 0) {
      writer.uint32(17).double(message.consumption);
    }
    if (message.generated !== 0) {
      writer.uint32(25).double(message.generated);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportedFreshWaterStatus {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportedFreshWaterStatus();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.rob = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.consumption = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.generated = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportedFreshWaterStatus {
    return {
      rob: isSet(object.rob) ? globalThis.Number(object.rob) : 0,
      consumption: isSet(object.consumption) ? globalThis.Number(object.consumption) : 0,
      generated: isSet(object.generated) ? globalThis.Number(object.generated) : 0,
    };
  },

  toJSON(message: VesselReportedFreshWaterStatus): unknown {
    const obj: any = {};
    if (message.rob !== 0) {
      obj.rob = message.rob;
    }
    if (message.consumption !== 0) {
      obj.consumption = message.consumption;
    }
    if (message.generated !== 0) {
      obj.generated = message.generated;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportedFreshWaterStatus>, I>>(base?: I): VesselReportedFreshWaterStatus {
    return VesselReportedFreshWaterStatus.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportedFreshWaterStatus>, I>>(
    object: I,
  ): VesselReportedFreshWaterStatus {
    const message = createBaseVesselReportedFreshWaterStatus();
    message.rob = object.rob ?? 0;
    message.consumption = object.consumption ?? 0;
    message.generated = object.generated ?? 0;
    return message;
  },
};

function createBaseVesselReportV202205(): VesselReportV202205 {
  return {
    vesselInfo: undefined,
    voyageNumber: "",
    reportType: "",
    reportDate: undefined,
    currentPlan: undefined,
    distances: undefined,
    vesselLocation: undefined,
    speed: undefined,
    weatherCondition: undefined,
    drafts: undefined,
    tanksCondition: [],
    bunkerReports: [],
    lubOilStatus: undefined,
    freshWaterStatus: undefined,
    ballastWaterTotalVolume: 0,
    comments: "",
    isGasFree: undefined,
  };
}

export const VesselReportV202205: MessageFns<VesselReportV202205> = {
  encode(message: VesselReportV202205, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselInfo !== undefined) {
      VesselInfo.encode(message.vesselInfo, writer.uint32(10).fork()).join();
    }
    if (message.voyageNumber !== "") {
      writer.uint32(18).string(message.voyageNumber);
    }
    if (message.reportType !== "") {
      writer.uint32(26).string(message.reportType);
    }
    if (message.reportDate !== undefined) {
      VesselReportDate.encode(message.reportDate, writer.uint32(34).fork()).join();
    }
    switch (message.currentPlan?.$case) {
      case "movingStatus":
        MovingStatus.encode(message.currentPlan.value, writer.uint32(42).fork()).join();
        break;
      case "stoppedStatus":
        StoppedStatus.encode(message.currentPlan.value, writer.uint32(50).fork()).join();
        break;
      case "unknownMovingStatus":
        UnknownMovingStatus.encode(message.currentPlan.value, writer.uint32(58).fork()).join();
        break;
    }
    if (message.distances !== undefined) {
      VesselReportedDistances.encode(message.distances, writer.uint32(66).fork()).join();
    }
    if (message.vesselLocation !== undefined) {
      VesselReportedLocation.encode(message.vesselLocation, writer.uint32(74).fork()).join();
    }
    if (message.speed !== undefined) {
      VesselReportedSpeed.encode(message.speed, writer.uint32(82).fork()).join();
    }
    if (message.weatherCondition !== undefined) {
      VesselReportedWeatherCondition.encode(message.weatherCondition, writer.uint32(90).fork()).join();
    }
    if (message.drafts !== undefined) {
      VesselReportedDraft.encode(message.drafts, writer.uint32(98).fork()).join();
    }
    for (const v of message.tanksCondition) {
      VesselReportedTankCondition.encode(v!, writer.uint32(106).fork()).join();
    }
    for (const v of message.bunkerReports) {
      VesselReportedMainEngineBunkerConsumption.encode(v!, writer.uint32(114).fork()).join();
    }
    if (message.lubOilStatus !== undefined) {
      VesselReportedLubOilStatus.encode(message.lubOilStatus, writer.uint32(122).fork()).join();
    }
    if (message.freshWaterStatus !== undefined) {
      VesselReportedFreshWaterStatus.encode(message.freshWaterStatus, writer.uint32(130).fork()).join();
    }
    if (message.ballastWaterTotalVolume !== 0) {
      writer.uint32(137).double(message.ballastWaterTotalVolume);
    }
    if (message.comments !== "") {
      writer.uint32(146).string(message.comments);
    }
    if (message.isGasFree !== undefined) {
      writer.uint32(152).bool(message.isGasFree);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VesselReportV202205 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVesselReportV202205();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselInfo = VesselInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.voyageNumber = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.reportType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.reportDate = VesselReportDate.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.currentPlan = { $case: "movingStatus", value: MovingStatus.decode(reader, reader.uint32()) };
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.currentPlan = { $case: "stoppedStatus", value: StoppedStatus.decode(reader, reader.uint32()) };
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.currentPlan = {
            $case: "unknownMovingStatus",
            value: UnknownMovingStatus.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.distances = VesselReportedDistances.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.vesselLocation = VesselReportedLocation.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.speed = VesselReportedSpeed.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.weatherCondition = VesselReportedWeatherCondition.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.drafts = VesselReportedDraft.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.tanksCondition.push(VesselReportedTankCondition.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.bunkerReports.push(VesselReportedMainEngineBunkerConsumption.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.lubOilStatus = VesselReportedLubOilStatus.decode(reader, reader.uint32());
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.freshWaterStatus = VesselReportedFreshWaterStatus.decode(reader, reader.uint32());
          continue;
        }
        case 17: {
          if (tag !== 137) {
            break;
          }

          message.ballastWaterTotalVolume = reader.double();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.isGasFree = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VesselReportV202205 {
    return {
      vesselInfo: isSet(object.vesselInfo)
        ? VesselInfo.fromJSON(object.vesselInfo)
        : isSet(object.vessel_info)
        ? VesselInfo.fromJSON(object.vessel_info)
        : undefined,
      voyageNumber: isSet(object.voyageNumber)
        ? globalThis.String(object.voyageNumber)
        : isSet(object.voyage_number)
        ? globalThis.String(object.voyage_number)
        : "",
      reportType: isSet(object.reportType)
        ? globalThis.String(object.reportType)
        : isSet(object.report_type)
        ? globalThis.String(object.report_type)
        : "",
      reportDate: isSet(object.reportDate)
        ? VesselReportDate.fromJSON(object.reportDate)
        : isSet(object.report_date)
        ? VesselReportDate.fromJSON(object.report_date)
        : undefined,
      currentPlan: isSet(object.movingStatus)
        ? { $case: "movingStatus", value: MovingStatus.fromJSON(object.movingStatus) }
        : isSet(object.moving_status)
        ? { $case: "movingStatus", value: MovingStatus.fromJSON(object.moving_status) }
        : isSet(object.stoppedStatus)
        ? { $case: "stoppedStatus", value: StoppedStatus.fromJSON(object.stoppedStatus) }
        : isSet(object.stopped_status)
        ? { $case: "stoppedStatus", value: StoppedStatus.fromJSON(object.stopped_status) }
        : isSet(object.unknownMovingStatus)
        ? { $case: "unknownMovingStatus", value: UnknownMovingStatus.fromJSON(object.unknownMovingStatus) }
        : isSet(object.unknown_moving_status)
        ? { $case: "unknownMovingStatus", value: UnknownMovingStatus.fromJSON(object.unknown_moving_status) }
        : undefined,
      distances: isSet(object.distances) ? VesselReportedDistances.fromJSON(object.distances) : undefined,
      vesselLocation: isSet(object.vesselLocation)
        ? VesselReportedLocation.fromJSON(object.vesselLocation)
        : isSet(object.vessel_location)
        ? VesselReportedLocation.fromJSON(object.vessel_location)
        : undefined,
      speed: isSet(object.speed) ? VesselReportedSpeed.fromJSON(object.speed) : undefined,
      weatherCondition: isSet(object.weatherCondition)
        ? VesselReportedWeatherCondition.fromJSON(object.weatherCondition)
        : isSet(object.weather_condition)
        ? VesselReportedWeatherCondition.fromJSON(object.weather_condition)
        : undefined,
      drafts: isSet(object.drafts) ? VesselReportedDraft.fromJSON(object.drafts) : undefined,
      tanksCondition: globalThis.Array.isArray(object?.tanksCondition)
        ? object.tanksCondition.map((e: any) => VesselReportedTankCondition.fromJSON(e))
        : globalThis.Array.isArray(object?.tanks_condition)
        ? object.tanks_condition.map((e: any) => VesselReportedTankCondition.fromJSON(e))
        : [],
      bunkerReports: globalThis.Array.isArray(object?.bunkerReports)
        ? object.bunkerReports.map((e: any) => VesselReportedMainEngineBunkerConsumption.fromJSON(e))
        : globalThis.Array.isArray(object?.bunker_reports)
        ? object.bunker_reports.map((e: any) => VesselReportedMainEngineBunkerConsumption.fromJSON(e))
        : [],
      lubOilStatus: isSet(object.lubOilStatus)
        ? VesselReportedLubOilStatus.fromJSON(object.lubOilStatus)
        : isSet(object.lub_oil_status)
        ? VesselReportedLubOilStatus.fromJSON(object.lub_oil_status)
        : undefined,
      freshWaterStatus: isSet(object.freshWaterStatus)
        ? VesselReportedFreshWaterStatus.fromJSON(object.freshWaterStatus)
        : isSet(object.fresh_water_status)
        ? VesselReportedFreshWaterStatus.fromJSON(object.fresh_water_status)
        : undefined,
      ballastWaterTotalVolume: isSet(object.ballastWaterTotalVolume)
        ? globalThis.Number(object.ballastWaterTotalVolume)
        : isSet(object.ballast_water_total_volume)
        ? globalThis.Number(object.ballast_water_total_volume)
        : 0,
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
      isGasFree: isSet(object.isGasFree)
        ? globalThis.Boolean(object.isGasFree)
        : isSet(object.is_gas_free)
        ? globalThis.Boolean(object.is_gas_free)
        : undefined,
    };
  },

  toJSON(message: VesselReportV202205): unknown {
    const obj: any = {};
    if (message.vesselInfo !== undefined) {
      obj.vesselInfo = VesselInfo.toJSON(message.vesselInfo);
    }
    if (message.voyageNumber !== "") {
      obj.voyageNumber = message.voyageNumber;
    }
    if (message.reportType !== "") {
      obj.reportType = message.reportType;
    }
    if (message.reportDate !== undefined) {
      obj.reportDate = VesselReportDate.toJSON(message.reportDate);
    }
    if (message.currentPlan?.$case === "movingStatus") {
      obj.movingStatus = MovingStatus.toJSON(message.currentPlan.value);
    } else if (message.currentPlan?.$case === "stoppedStatus") {
      obj.stoppedStatus = StoppedStatus.toJSON(message.currentPlan.value);
    } else if (message.currentPlan?.$case === "unknownMovingStatus") {
      obj.unknownMovingStatus = UnknownMovingStatus.toJSON(message.currentPlan.value);
    }
    if (message.distances !== undefined) {
      obj.distances = VesselReportedDistances.toJSON(message.distances);
    }
    if (message.vesselLocation !== undefined) {
      obj.vesselLocation = VesselReportedLocation.toJSON(message.vesselLocation);
    }
    if (message.speed !== undefined) {
      obj.speed = VesselReportedSpeed.toJSON(message.speed);
    }
    if (message.weatherCondition !== undefined) {
      obj.weatherCondition = VesselReportedWeatherCondition.toJSON(message.weatherCondition);
    }
    if (message.drafts !== undefined) {
      obj.drafts = VesselReportedDraft.toJSON(message.drafts);
    }
    if (message.tanksCondition?.length) {
      obj.tanksCondition = message.tanksCondition.map((e) => VesselReportedTankCondition.toJSON(e));
    }
    if (message.bunkerReports?.length) {
      obj.bunkerReports = message.bunkerReports.map((e) => VesselReportedMainEngineBunkerConsumption.toJSON(e));
    }
    if (message.lubOilStatus !== undefined) {
      obj.lubOilStatus = VesselReportedLubOilStatus.toJSON(message.lubOilStatus);
    }
    if (message.freshWaterStatus !== undefined) {
      obj.freshWaterStatus = VesselReportedFreshWaterStatus.toJSON(message.freshWaterStatus);
    }
    if (message.ballastWaterTotalVolume !== 0) {
      obj.ballastWaterTotalVolume = message.ballastWaterTotalVolume;
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    if (message.isGasFree !== undefined) {
      obj.isGasFree = message.isGasFree;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VesselReportV202205>, I>>(base?: I): VesselReportV202205 {
    return VesselReportV202205.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VesselReportV202205>, I>>(object: I): VesselReportV202205 {
    const message = createBaseVesselReportV202205();
    message.vesselInfo = (object.vesselInfo !== undefined && object.vesselInfo !== null)
      ? VesselInfo.fromPartial(object.vesselInfo)
      : undefined;
    message.voyageNumber = object.voyageNumber ?? "";
    message.reportType = object.reportType ?? "";
    message.reportDate = (object.reportDate !== undefined && object.reportDate !== null)
      ? VesselReportDate.fromPartial(object.reportDate)
      : undefined;
    switch (object.currentPlan?.$case) {
      case "movingStatus": {
        if (object.currentPlan?.value !== undefined && object.currentPlan?.value !== null) {
          message.currentPlan = { $case: "movingStatus", value: MovingStatus.fromPartial(object.currentPlan.value) };
        }
        break;
      }
      case "stoppedStatus": {
        if (object.currentPlan?.value !== undefined && object.currentPlan?.value !== null) {
          message.currentPlan = { $case: "stoppedStatus", value: StoppedStatus.fromPartial(object.currentPlan.value) };
        }
        break;
      }
      case "unknownMovingStatus": {
        if (object.currentPlan?.value !== undefined && object.currentPlan?.value !== null) {
          message.currentPlan = {
            $case: "unknownMovingStatus",
            value: UnknownMovingStatus.fromPartial(object.currentPlan.value),
          };
        }
        break;
      }
    }
    message.distances = (object.distances !== undefined && object.distances !== null)
      ? VesselReportedDistances.fromPartial(object.distances)
      : undefined;
    message.vesselLocation = (object.vesselLocation !== undefined && object.vesselLocation !== null)
      ? VesselReportedLocation.fromPartial(object.vesselLocation)
      : undefined;
    message.speed = (object.speed !== undefined && object.speed !== null)
      ? VesselReportedSpeed.fromPartial(object.speed)
      : undefined;
    message.weatherCondition = (object.weatherCondition !== undefined && object.weatherCondition !== null)
      ? VesselReportedWeatherCondition.fromPartial(object.weatherCondition)
      : undefined;
    message.drafts = (object.drafts !== undefined && object.drafts !== null)
      ? VesselReportedDraft.fromPartial(object.drafts)
      : undefined;
    message.tanksCondition = object.tanksCondition?.map((e) => VesselReportedTankCondition.fromPartial(e)) || [];
    message.bunkerReports =
      object.bunkerReports?.map((e) => VesselReportedMainEngineBunkerConsumption.fromPartial(e)) || [];
    message.lubOilStatus = (object.lubOilStatus !== undefined && object.lubOilStatus !== null)
      ? VesselReportedLubOilStatus.fromPartial(object.lubOilStatus)
      : undefined;
    message.freshWaterStatus = (object.freshWaterStatus !== undefined && object.freshWaterStatus !== null)
      ? VesselReportedFreshWaterStatus.fromPartial(object.freshWaterStatus)
      : undefined;
    message.ballastWaterTotalVolume = object.ballastWaterTotalVolume ?? 0;
    message.comments = object.comments ?? "";
    message.isGasFree = object.isGasFree ?? undefined;
    return message;
  },
};

function createBaseGetVesselReportV202205Response(): GetVesselReportV202205Response {
  return { reports: [] };
}

export const GetVesselReportV202205Response: MessageFns<GetVesselReportV202205Response> = {
  encode(message: GetVesselReportV202205Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.reports) {
      VesselReportV202205.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetVesselReportV202205Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetVesselReportV202205Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reports.push(VesselReportV202205.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetVesselReportV202205Response {
    return {
      reports: globalThis.Array.isArray(object?.reports)
        ? object.reports.map((e: any) => VesselReportV202205.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetVesselReportV202205Response): unknown {
    const obj: any = {};
    if (message.reports?.length) {
      obj.reports = message.reports.map((e) => VesselReportV202205.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetVesselReportV202205Response>, I>>(base?: I): GetVesselReportV202205Response {
    return GetVesselReportV202205Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetVesselReportV202205Response>, I>>(
    object: I,
  ): GetVesselReportV202205Response {
    const message = createBaseGetVesselReportV202205Response();
    message.reports = object.reports?.map((e) => VesselReportV202205.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetNoonReportV202005Response(): GetNoonReportV202005Response {
  return { reports: [] };
}

export const GetNoonReportV202005Response: MessageFns<GetNoonReportV202005Response> = {
  encode(message: GetNoonReportV202005Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.reports) {
      NoonReportV202005.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNoonReportV202005Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNoonReportV202005Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reports.push(NoonReportV202005.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNoonReportV202005Response {
    return {
      reports: globalThis.Array.isArray(object?.reports)
        ? object.reports.map((e: any) => NoonReportV202005.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetNoonReportV202005Response): unknown {
    const obj: any = {};
    if (message.reports?.length) {
      obj.reports = message.reports.map((e) => NoonReportV202005.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNoonReportV202005Response>, I>>(base?: I): GetNoonReportV202005Response {
    return GetNoonReportV202005Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNoonReportV202005Response>, I>>(object: I): GetNoonReportV202005Response {
    const message = createBaseGetNoonReportV202005Response();
    message.reports = object.reports?.map((e) => NoonReportV202005.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGeoCoordinateDoublev202005(): GeoCoordinateDoublev202005 {
  return { latitude: 0, longitude: 0 };
}

export const GeoCoordinateDoublev202005: MessageFns<GeoCoordinateDoublev202005> = {
  encode(message: GeoCoordinateDoublev202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.latitude !== 0) {
      writer.uint32(9).double(message.latitude);
    }
    if (message.longitude !== 0) {
      writer.uint32(17).double(message.longitude);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GeoCoordinateDoublev202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGeoCoordinateDoublev202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GeoCoordinateDoublev202005 {
    return {
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
    };
  },

  toJSON(message: GeoCoordinateDoublev202005): unknown {
    const obj: any = {};
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GeoCoordinateDoublev202005>, I>>(base?: I): GeoCoordinateDoublev202005 {
    return GeoCoordinateDoublev202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GeoCoordinateDoublev202005>, I>>(object: I): GeoCoordinateDoublev202005 {
    const message = createBaseGeoCoordinateDoublev202005();
    message.latitude = object.latitude ?? 0;
    message.longitude = object.longitude ?? 0;
    return message;
  },
};

function createBaseNoonReportDatev202005(): NoonReportDatev202005 {
  return { timestamp: 0, hoursSinceLastReport: 0, totalSteamingTime: 0 };
}

export const NoonReportDatev202005: MessageFns<NoonReportDatev202005> = {
  encode(message: NoonReportDatev202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== 0) {
      writer.uint32(8).int64(message.timestamp);
    }
    if (message.hoursSinceLastReport !== 0) {
      writer.uint32(17).double(message.hoursSinceLastReport);
    }
    if (message.totalSteamingTime !== 0) {
      writer.uint32(25).double(message.totalSteamingTime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportDatev202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportDatev202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.timestamp = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.hoursSinceLastReport = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.totalSteamingTime = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportDatev202005 {
    return {
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      hoursSinceLastReport: isSet(object.hoursSinceLastReport)
        ? globalThis.Number(object.hoursSinceLastReport)
        : isSet(object.hours_since_last_report)
        ? globalThis.Number(object.hours_since_last_report)
        : 0,
      totalSteamingTime: isSet(object.totalSteamingTime)
        ? globalThis.Number(object.totalSteamingTime)
        : isSet(object.total_steaming_time)
        ? globalThis.Number(object.total_steaming_time)
        : 0,
    };
  },

  toJSON(message: NoonReportDatev202005): unknown {
    const obj: any = {};
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.hoursSinceLastReport !== 0) {
      obj.hoursSinceLastReport = message.hoursSinceLastReport;
    }
    if (message.totalSteamingTime !== 0) {
      obj.totalSteamingTime = message.totalSteamingTime;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportDatev202005>, I>>(base?: I): NoonReportDatev202005 {
    return NoonReportDatev202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportDatev202005>, I>>(object: I): NoonReportDatev202005 {
    const message = createBaseNoonReportDatev202005();
    message.timestamp = object.timestamp ?? 0;
    message.hoursSinceLastReport = object.hoursSinceLastReport ?? 0;
    message.totalSteamingTime = object.totalSteamingTime ?? 0;
    return message;
  },
};

function createBaseNoonReportVoyageDetailsv202005(): NoonReportVoyageDetailsv202005 {
  return {
    voyageNumber: "",
    source: "",
    destination: "",
    isLaden: false,
    eta: 0,
    distanceCovered: 0,
    distanceByMainEngine: 0,
    distanceToGo: 0,
    totalDistanceRun: 0,
  };
}

export const NoonReportVoyageDetailsv202005: MessageFns<NoonReportVoyageDetailsv202005> = {
  encode(message: NoonReportVoyageDetailsv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.voyageNumber !== "") {
      writer.uint32(10).string(message.voyageNumber);
    }
    if (message.source !== "") {
      writer.uint32(18).string(message.source);
    }
    if (message.destination !== "") {
      writer.uint32(26).string(message.destination);
    }
    if (message.isLaden !== false) {
      writer.uint32(32).bool(message.isLaden);
    }
    if (message.eta !== 0) {
      writer.uint32(40).int64(message.eta);
    }
    if (message.distanceCovered !== 0) {
      writer.uint32(49).double(message.distanceCovered);
    }
    if (message.distanceByMainEngine !== 0) {
      writer.uint32(57).double(message.distanceByMainEngine);
    }
    if (message.distanceToGo !== 0) {
      writer.uint32(65).double(message.distanceToGo);
    }
    if (message.totalDistanceRun !== 0) {
      writer.uint32(73).double(message.totalDistanceRun);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportVoyageDetailsv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportVoyageDetailsv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.voyageNumber = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.source = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.destination = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isLaden = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.eta = longToNumber(reader.int64());
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.distanceCovered = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.distanceByMainEngine = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.distanceToGo = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.totalDistanceRun = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportVoyageDetailsv202005 {
    return {
      voyageNumber: isSet(object.voyageNumber)
        ? globalThis.String(object.voyageNumber)
        : isSet(object.voyage_number)
        ? globalThis.String(object.voyage_number)
        : "",
      source: isSet(object.source) ? globalThis.String(object.source) : "",
      destination: isSet(object.destination) ? globalThis.String(object.destination) : "",
      isLaden: isSet(object.isLaden)
        ? globalThis.Boolean(object.isLaden)
        : isSet(object.is_laden)
        ? globalThis.Boolean(object.is_laden)
        : false,
      eta: isSet(object.eta) ? globalThis.Number(object.eta) : 0,
      distanceCovered: isSet(object.distanceCovered)
        ? globalThis.Number(object.distanceCovered)
        : isSet(object.distance_covered)
        ? globalThis.Number(object.distance_covered)
        : 0,
      distanceByMainEngine: isSet(object.distanceByMainEngine)
        ? globalThis.Number(object.distanceByMainEngine)
        : isSet(object.distance_by_main_engine)
        ? globalThis.Number(object.distance_by_main_engine)
        : 0,
      distanceToGo: isSet(object.distanceToGo)
        ? globalThis.Number(object.distanceToGo)
        : isSet(object.distance_to_go)
        ? globalThis.Number(object.distance_to_go)
        : 0,
      totalDistanceRun: isSet(object.totalDistanceRun)
        ? globalThis.Number(object.totalDistanceRun)
        : isSet(object.total_distance_run)
        ? globalThis.Number(object.total_distance_run)
        : 0,
    };
  },

  toJSON(message: NoonReportVoyageDetailsv202005): unknown {
    const obj: any = {};
    if (message.voyageNumber !== "") {
      obj.voyageNumber = message.voyageNumber;
    }
    if (message.source !== "") {
      obj.source = message.source;
    }
    if (message.destination !== "") {
      obj.destination = message.destination;
    }
    if (message.isLaden !== false) {
      obj.isLaden = message.isLaden;
    }
    if (message.eta !== 0) {
      obj.eta = Math.round(message.eta);
    }
    if (message.distanceCovered !== 0) {
      obj.distanceCovered = message.distanceCovered;
    }
    if (message.distanceByMainEngine !== 0) {
      obj.distanceByMainEngine = message.distanceByMainEngine;
    }
    if (message.distanceToGo !== 0) {
      obj.distanceToGo = message.distanceToGo;
    }
    if (message.totalDistanceRun !== 0) {
      obj.totalDistanceRun = message.totalDistanceRun;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportVoyageDetailsv202005>, I>>(base?: I): NoonReportVoyageDetailsv202005 {
    return NoonReportVoyageDetailsv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportVoyageDetailsv202005>, I>>(
    object: I,
  ): NoonReportVoyageDetailsv202005 {
    const message = createBaseNoonReportVoyageDetailsv202005();
    message.voyageNumber = object.voyageNumber ?? "";
    message.source = object.source ?? "";
    message.destination = object.destination ?? "";
    message.isLaden = object.isLaden ?? false;
    message.eta = object.eta ?? 0;
    message.distanceCovered = object.distanceCovered ?? 0;
    message.distanceByMainEngine = object.distanceByMainEngine ?? 0;
    message.distanceToGo = object.distanceToGo ?? 0;
    message.totalDistanceRun = object.totalDistanceRun ?? 0;
    return message;
  },
};

function createBaseNoonReportPositionv202005(): NoonReportPositionv202005 {
  return { geoCoordinate: undefined, currentLocation: "" };
}

export const NoonReportPositionv202005: MessageFns<NoonReportPositionv202005> = {
  encode(message: NoonReportPositionv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.geoCoordinate !== undefined) {
      GeoCoordinateDoublev202005.encode(message.geoCoordinate, writer.uint32(10).fork()).join();
    }
    if (message.currentLocation !== "") {
      writer.uint32(18).string(message.currentLocation);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportPositionv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportPositionv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.geoCoordinate = GeoCoordinateDoublev202005.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currentLocation = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportPositionv202005 {
    return {
      geoCoordinate: isSet(object.geoCoordinate)
        ? GeoCoordinateDoublev202005.fromJSON(object.geoCoordinate)
        : isSet(object.geo_coordinate)
        ? GeoCoordinateDoublev202005.fromJSON(object.geo_coordinate)
        : undefined,
      currentLocation: isSet(object.currentLocation)
        ? globalThis.String(object.currentLocation)
        : isSet(object.current_location)
        ? globalThis.String(object.current_location)
        : "",
    };
  },

  toJSON(message: NoonReportPositionv202005): unknown {
    const obj: any = {};
    if (message.geoCoordinate !== undefined) {
      obj.geoCoordinate = GeoCoordinateDoublev202005.toJSON(message.geoCoordinate);
    }
    if (message.currentLocation !== "") {
      obj.currentLocation = message.currentLocation;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportPositionv202005>, I>>(base?: I): NoonReportPositionv202005 {
    return NoonReportPositionv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportPositionv202005>, I>>(object: I): NoonReportPositionv202005 {
    const message = createBaseNoonReportPositionv202005();
    message.geoCoordinate = (object.geoCoordinate !== undefined && object.geoCoordinate !== null)
      ? GeoCoordinateDoublev202005.fromPartial(object.geoCoordinate)
      : undefined;
    message.currentLocation = object.currentLocation ?? "";
    return message;
  },
};

function createBaseNoonReportSpeedv202005(): NoonReportSpeedv202005 {
  return { speed: 0, averageSpeed: 0, mainEngineAverageRpm: 0 };
}

export const NoonReportSpeedv202005: MessageFns<NoonReportSpeedv202005> = {
  encode(message: NoonReportSpeedv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.speed !== 0) {
      writer.uint32(9).double(message.speed);
    }
    if (message.averageSpeed !== 0) {
      writer.uint32(17).double(message.averageSpeed);
    }
    if (message.mainEngineAverageRpm !== 0) {
      writer.uint32(25).double(message.mainEngineAverageRpm);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportSpeedv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportSpeedv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.speed = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.averageSpeed = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.mainEngineAverageRpm = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportSpeedv202005 {
    return {
      speed: isSet(object.speed) ? globalThis.Number(object.speed) : 0,
      averageSpeed: isSet(object.averageSpeed)
        ? globalThis.Number(object.averageSpeed)
        : isSet(object.average_speed)
        ? globalThis.Number(object.average_speed)
        : 0,
      mainEngineAverageRpm: isSet(object.mainEngineAverageRpm)
        ? globalThis.Number(object.mainEngineAverageRpm)
        : isSet(object.main_engine_average_rpm)
        ? globalThis.Number(object.main_engine_average_rpm)
        : 0,
    };
  },

  toJSON(message: NoonReportSpeedv202005): unknown {
    const obj: any = {};
    if (message.speed !== 0) {
      obj.speed = message.speed;
    }
    if (message.averageSpeed !== 0) {
      obj.averageSpeed = message.averageSpeed;
    }
    if (message.mainEngineAverageRpm !== 0) {
      obj.mainEngineAverageRpm = message.mainEngineAverageRpm;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportSpeedv202005>, I>>(base?: I): NoonReportSpeedv202005 {
    return NoonReportSpeedv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportSpeedv202005>, I>>(object: I): NoonReportSpeedv202005 {
    const message = createBaseNoonReportSpeedv202005();
    message.speed = object.speed ?? 0;
    message.averageSpeed = object.averageSpeed ?? 0;
    message.mainEngineAverageRpm = object.mainEngineAverageRpm ?? 0;
    return message;
  },
};

function createBaseNoonReportConditionv202005(): NoonReportConditionv202005 {
  return {
    seaForce: 0,
    seaForceDirection: "",
    windForce: 0,
    windForceDirection: "",
    currentForce: 0,
    currentForceDirection: "",
    forwardDraft: 0,
    middleDraft: 0,
    aftDraft: 0,
  };
}

export const NoonReportConditionv202005: MessageFns<NoonReportConditionv202005> = {
  encode(message: NoonReportConditionv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.seaForce !== 0) {
      writer.uint32(9).double(message.seaForce);
    }
    if (message.seaForceDirection !== "") {
      writer.uint32(18).string(message.seaForceDirection);
    }
    if (message.windForce !== 0) {
      writer.uint32(25).double(message.windForce);
    }
    if (message.windForceDirection !== "") {
      writer.uint32(34).string(message.windForceDirection);
    }
    if (message.currentForce !== 0) {
      writer.uint32(41).double(message.currentForce);
    }
    if (message.currentForceDirection !== "") {
      writer.uint32(50).string(message.currentForceDirection);
    }
    if (message.forwardDraft !== 0) {
      writer.uint32(57).double(message.forwardDraft);
    }
    if (message.middleDraft !== 0) {
      writer.uint32(65).double(message.middleDraft);
    }
    if (message.aftDraft !== 0) {
      writer.uint32(73).double(message.aftDraft);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportConditionv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportConditionv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.seaForce = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.seaForceDirection = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.windForce = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.windForceDirection = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.currentForce = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.currentForceDirection = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.forwardDraft = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.middleDraft = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.aftDraft = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportConditionv202005 {
    return {
      seaForce: isSet(object.seaForce)
        ? globalThis.Number(object.seaForce)
        : isSet(object.sea_force)
        ? globalThis.Number(object.sea_force)
        : 0,
      seaForceDirection: isSet(object.seaForceDirection)
        ? globalThis.String(object.seaForceDirection)
        : isSet(object.sea_force_direction)
        ? globalThis.String(object.sea_force_direction)
        : "",
      windForce: isSet(object.windForce)
        ? globalThis.Number(object.windForce)
        : isSet(object.wind_force)
        ? globalThis.Number(object.wind_force)
        : 0,
      windForceDirection: isSet(object.windForceDirection)
        ? globalThis.String(object.windForceDirection)
        : isSet(object.wind_force_direction)
        ? globalThis.String(object.wind_force_direction)
        : "",
      currentForce: isSet(object.currentForce)
        ? globalThis.Number(object.currentForce)
        : isSet(object.current_force)
        ? globalThis.Number(object.current_force)
        : 0,
      currentForceDirection: isSet(object.currentForceDirection)
        ? globalThis.String(object.currentForceDirection)
        : isSet(object.current_force_direction)
        ? globalThis.String(object.current_force_direction)
        : "",
      forwardDraft: isSet(object.forwardDraft)
        ? globalThis.Number(object.forwardDraft)
        : isSet(object.forward_draft)
        ? globalThis.Number(object.forward_draft)
        : 0,
      middleDraft: isSet(object.middleDraft)
        ? globalThis.Number(object.middleDraft)
        : isSet(object.middle_draft)
        ? globalThis.Number(object.middle_draft)
        : 0,
      aftDraft: isSet(object.aftDraft)
        ? globalThis.Number(object.aftDraft)
        : isSet(object.aft_draft)
        ? globalThis.Number(object.aft_draft)
        : 0,
    };
  },

  toJSON(message: NoonReportConditionv202005): unknown {
    const obj: any = {};
    if (message.seaForce !== 0) {
      obj.seaForce = message.seaForce;
    }
    if (message.seaForceDirection !== "") {
      obj.seaForceDirection = message.seaForceDirection;
    }
    if (message.windForce !== 0) {
      obj.windForce = message.windForce;
    }
    if (message.windForceDirection !== "") {
      obj.windForceDirection = message.windForceDirection;
    }
    if (message.currentForce !== 0) {
      obj.currentForce = message.currentForce;
    }
    if (message.currentForceDirection !== "") {
      obj.currentForceDirection = message.currentForceDirection;
    }
    if (message.forwardDraft !== 0) {
      obj.forwardDraft = message.forwardDraft;
    }
    if (message.middleDraft !== 0) {
      obj.middleDraft = message.middleDraft;
    }
    if (message.aftDraft !== 0) {
      obj.aftDraft = message.aftDraft;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportConditionv202005>, I>>(base?: I): NoonReportConditionv202005 {
    return NoonReportConditionv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportConditionv202005>, I>>(object: I): NoonReportConditionv202005 {
    const message = createBaseNoonReportConditionv202005();
    message.seaForce = object.seaForce ?? 0;
    message.seaForceDirection = object.seaForceDirection ?? "";
    message.windForce = object.windForce ?? 0;
    message.windForceDirection = object.windForceDirection ?? "";
    message.currentForce = object.currentForce ?? 0;
    message.currentForceDirection = object.currentForceDirection ?? "";
    message.forwardDraft = object.forwardDraft ?? 0;
    message.middleDraft = object.middleDraft ?? 0;
    message.aftDraft = object.aftDraft ?? 0;
    return message;
  },
};

function createBaseNoonReportTankConditionv202005(): NoonReportTankConditionv202005 {
  return { tankNo: "", product: "", quantity: 0, temperature: 0 };
}

export const NoonReportTankConditionv202005: MessageFns<NoonReportTankConditionv202005> = {
  encode(message: NoonReportTankConditionv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tankNo !== "") {
      writer.uint32(10).string(message.tankNo);
    }
    if (message.product !== "") {
      writer.uint32(18).string(message.product);
    }
    if (message.quantity !== 0) {
      writer.uint32(25).double(message.quantity);
    }
    if (message.temperature !== 0) {
      writer.uint32(33).double(message.temperature);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportTankConditionv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportTankConditionv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tankNo = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.product = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.quantity = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.temperature = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportTankConditionv202005 {
    return {
      tankNo: isSet(object.tankNo)
        ? globalThis.String(object.tankNo)
        : isSet(object.tank_no)
        ? globalThis.String(object.tank_no)
        : "",
      product: isSet(object.product) ? globalThis.String(object.product) : "",
      quantity: isSet(object.quantity) ? globalThis.Number(object.quantity) : 0,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : 0,
    };
  },

  toJSON(message: NoonReportTankConditionv202005): unknown {
    const obj: any = {};
    if (message.tankNo !== "") {
      obj.tankNo = message.tankNo;
    }
    if (message.product !== "") {
      obj.product = message.product;
    }
    if (message.quantity !== 0) {
      obj.quantity = message.quantity;
    }
    if (message.temperature !== 0) {
      obj.temperature = message.temperature;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportTankConditionv202005>, I>>(base?: I): NoonReportTankConditionv202005 {
    return NoonReportTankConditionv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportTankConditionv202005>, I>>(
    object: I,
  ): NoonReportTankConditionv202005 {
    const message = createBaseNoonReportTankConditionv202005();
    message.tankNo = object.tankNo ?? "";
    message.product = object.product ?? "";
    message.quantity = object.quantity ?? 0;
    message.temperature = object.temperature ?? 0;
    return message;
  },
};

function createBaseNoonReportBunkerv202005(): NoonReportBunkerv202005 {
  return { bunkerType: "", quantityMt: 0 };
}

export const NoonReportBunkerv202005: MessageFns<NoonReportBunkerv202005> = {
  encode(message: NoonReportBunkerv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bunkerType !== "") {
      writer.uint32(10).string(message.bunkerType);
    }
    if (message.quantityMt !== 0) {
      writer.uint32(17).double(message.quantityMt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportBunkerv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportBunkerv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.bunkerType = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.quantityMt = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportBunkerv202005 {
    return {
      bunkerType: isSet(object.bunkerType)
        ? globalThis.String(object.bunkerType)
        : isSet(object.bunker_type)
        ? globalThis.String(object.bunker_type)
        : "",
      quantityMt: isSet(object.quantityMt)
        ? globalThis.Number(object.quantityMt)
        : isSet(object.quantity_mt)
        ? globalThis.Number(object.quantity_mt)
        : 0,
    };
  },

  toJSON(message: NoonReportBunkerv202005): unknown {
    const obj: any = {};
    if (message.bunkerType !== "") {
      obj.bunkerType = message.bunkerType;
    }
    if (message.quantityMt !== 0) {
      obj.quantityMt = message.quantityMt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportBunkerv202005>, I>>(base?: I): NoonReportBunkerv202005 {
    return NoonReportBunkerv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportBunkerv202005>, I>>(object: I): NoonReportBunkerv202005 {
    const message = createBaseNoonReportBunkerv202005();
    message.bunkerType = object.bunkerType ?? "";
    message.quantityMt = object.quantityMt ?? 0;
    return message;
  },
};

function createBaseNoonReportLastReceivedv202005(): NoonReportLastReceivedv202005 {
  return { receivedType: "", timestamp: 0, quantityMt: 0 };
}

export const NoonReportLastReceivedv202005: MessageFns<NoonReportLastReceivedv202005> = {
  encode(message: NoonReportLastReceivedv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.receivedType !== "") {
      writer.uint32(10).string(message.receivedType);
    }
    if (message.timestamp !== 0) {
      writer.uint32(16).int64(message.timestamp);
    }
    if (message.quantityMt !== 0) {
      writer.uint32(25).double(message.quantityMt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportLastReceivedv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportLastReceivedv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.receivedType = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.timestamp = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.quantityMt = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportLastReceivedv202005 {
    return {
      receivedType: isSet(object.receivedType)
        ? globalThis.String(object.receivedType)
        : isSet(object.received_type)
        ? globalThis.String(object.received_type)
        : "",
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      quantityMt: isSet(object.quantityMt)
        ? globalThis.Number(object.quantityMt)
        : isSet(object.quantity_mt)
        ? globalThis.Number(object.quantity_mt)
        : 0,
    };
  },

  toJSON(message: NoonReportLastReceivedv202005): unknown {
    const obj: any = {};
    if (message.receivedType !== "") {
      obj.receivedType = message.receivedType;
    }
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.quantityMt !== 0) {
      obj.quantityMt = message.quantityMt;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportLastReceivedv202005>, I>>(base?: I): NoonReportLastReceivedv202005 {
    return NoonReportLastReceivedv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportLastReceivedv202005>, I>>(
    object: I,
  ): NoonReportLastReceivedv202005 {
    const message = createBaseNoonReportLastReceivedv202005();
    message.receivedType = object.receivedType ?? "";
    message.timestamp = object.timestamp ?? 0;
    message.quantityMt = object.quantityMt ?? 0;
    return message;
  },
};

function createBaseNoonReportSailingBunkerConsumptionv202005(): NoonReportSailingBunkerConsumptionv202005 {
  return { status: 0, hours: 0, averageRpm: 0, bunkerConsumption: [] };
}

export const NoonReportSailingBunkerConsumptionv202005: MessageFns<NoonReportSailingBunkerConsumptionv202005> = {
  encode(message: NoonReportSailingBunkerConsumptionv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.hours !== 0) {
      writer.uint32(17).double(message.hours);
    }
    if (message.averageRpm !== 0) {
      writer.uint32(25).double(message.averageRpm);
    }
    for (const v of message.bunkerConsumption) {
      NoonReportBunkerv202005.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportSailingBunkerConsumptionv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportSailingBunkerConsumptionv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.hours = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.averageRpm = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.bunkerConsumption.push(NoonReportBunkerv202005.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportSailingBunkerConsumptionv202005 {
    return {
      status: isSet(object.status) ? sailingStatusv202005FromJSON(object.status) : 0,
      hours: isSet(object.hours) ? globalThis.Number(object.hours) : 0,
      averageRpm: isSet(object.averageRpm)
        ? globalThis.Number(object.averageRpm)
        : isSet(object.average_rpm)
        ? globalThis.Number(object.average_rpm)
        : 0,
      bunkerConsumption: globalThis.Array.isArray(object?.bunkerConsumption)
        ? object.bunkerConsumption.map((e: any) => NoonReportBunkerv202005.fromJSON(e))
        : globalThis.Array.isArray(object?.bunker_consumption)
        ? object.bunker_consumption.map((e: any) => NoonReportBunkerv202005.fromJSON(e))
        : [],
    };
  },

  toJSON(message: NoonReportSailingBunkerConsumptionv202005): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = sailingStatusv202005ToJSON(message.status);
    }
    if (message.hours !== 0) {
      obj.hours = message.hours;
    }
    if (message.averageRpm !== 0) {
      obj.averageRpm = message.averageRpm;
    }
    if (message.bunkerConsumption?.length) {
      obj.bunkerConsumption = message.bunkerConsumption.map((e) => NoonReportBunkerv202005.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportSailingBunkerConsumptionv202005>, I>>(
    base?: I,
  ): NoonReportSailingBunkerConsumptionv202005 {
    return NoonReportSailingBunkerConsumptionv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportSailingBunkerConsumptionv202005>, I>>(
    object: I,
  ): NoonReportSailingBunkerConsumptionv202005 {
    const message = createBaseNoonReportSailingBunkerConsumptionv202005();
    message.status = object.status ?? 0;
    message.hours = object.hours ?? 0;
    message.averageRpm = object.averageRpm ?? 0;
    message.bunkerConsumption = object.bunkerConsumption?.map((e) => NoonReportBunkerv202005.fromPartial(e)) || [];
    return message;
  },
};

function createBaseNoonReportOtherBunkerConsumptionv202005(): NoonReportOtherBunkerConsumptionv202005 {
  return { partName: "", bunkerConsumption: [] };
}

export const NoonReportOtherBunkerConsumptionv202005: MessageFns<NoonReportOtherBunkerConsumptionv202005> = {
  encode(message: NoonReportOtherBunkerConsumptionv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.partName !== "") {
      writer.uint32(10).string(message.partName);
    }
    for (const v of message.bunkerConsumption) {
      NoonReportBunkerv202005.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportOtherBunkerConsumptionv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportOtherBunkerConsumptionv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.partName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.bunkerConsumption.push(NoonReportBunkerv202005.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportOtherBunkerConsumptionv202005 {
    return {
      partName: isSet(object.partName)
        ? globalThis.String(object.partName)
        : isSet(object.part_name)
        ? globalThis.String(object.part_name)
        : "",
      bunkerConsumption: globalThis.Array.isArray(object?.bunkerConsumption)
        ? object.bunkerConsumption.map((e: any) => NoonReportBunkerv202005.fromJSON(e))
        : globalThis.Array.isArray(object?.bunker_consumption)
        ? object.bunker_consumption.map((e: any) => NoonReportBunkerv202005.fromJSON(e))
        : [],
    };
  },

  toJSON(message: NoonReportOtherBunkerConsumptionv202005): unknown {
    const obj: any = {};
    if (message.partName !== "") {
      obj.partName = message.partName;
    }
    if (message.bunkerConsumption?.length) {
      obj.bunkerConsumption = message.bunkerConsumption.map((e) => NoonReportBunkerv202005.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportOtherBunkerConsumptionv202005>, I>>(
    base?: I,
  ): NoonReportOtherBunkerConsumptionv202005 {
    return NoonReportOtherBunkerConsumptionv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportOtherBunkerConsumptionv202005>, I>>(
    object: I,
  ): NoonReportOtherBunkerConsumptionv202005 {
    const message = createBaseNoonReportOtherBunkerConsumptionv202005();
    message.partName = object.partName ?? "";
    message.bunkerConsumption = object.bunkerConsumption?.map((e) => NoonReportBunkerv202005.fromPartial(e)) || [];
    return message;
  },
};

function createBaseNoonReportBunkerStatusv202005(): NoonReportBunkerStatusv202005 {
  return { sailingBunkerConsumption: [], otherBunkerConsumption: [], rob: [], lastReceived: [] };
}

export const NoonReportBunkerStatusv202005: MessageFns<NoonReportBunkerStatusv202005> = {
  encode(message: NoonReportBunkerStatusv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.sailingBunkerConsumption) {
      NoonReportSailingBunkerConsumptionv202005.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.otherBunkerConsumption) {
      NoonReportOtherBunkerConsumptionv202005.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.rob) {
      NoonReportBunkerv202005.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.lastReceived) {
      NoonReportLastReceivedv202005.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportBunkerStatusv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportBunkerStatusv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sailingBunkerConsumption.push(
            NoonReportSailingBunkerConsumptionv202005.decode(reader, reader.uint32()),
          );
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.otherBunkerConsumption.push(NoonReportOtherBunkerConsumptionv202005.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rob.push(NoonReportBunkerv202005.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.lastReceived.push(NoonReportLastReceivedv202005.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportBunkerStatusv202005 {
    return {
      sailingBunkerConsumption: globalThis.Array.isArray(object?.sailingBunkerConsumption)
        ? object.sailingBunkerConsumption.map((e: any) => NoonReportSailingBunkerConsumptionv202005.fromJSON(e))
        : globalThis.Array.isArray(object?.sailing_bunker_consumption)
        ? object.sailing_bunker_consumption.map((e: any) => NoonReportSailingBunkerConsumptionv202005.fromJSON(e))
        : [],
      otherBunkerConsumption: globalThis.Array.isArray(object?.otherBunkerConsumption)
        ? object.otherBunkerConsumption.map((e: any) => NoonReportOtherBunkerConsumptionv202005.fromJSON(e))
        : globalThis.Array.isArray(object?.other_bunker_consumption)
        ? object.other_bunker_consumption.map((e: any) => NoonReportOtherBunkerConsumptionv202005.fromJSON(e))
        : [],
      rob: globalThis.Array.isArray(object?.rob) ? object.rob.map((e: any) => NoonReportBunkerv202005.fromJSON(e)) : [],
      lastReceived: globalThis.Array.isArray(object?.lastReceived)
        ? object.lastReceived.map((e: any) => NoonReportLastReceivedv202005.fromJSON(e))
        : globalThis.Array.isArray(object?.last_received)
        ? object.last_received.map((e: any) => NoonReportLastReceivedv202005.fromJSON(e))
        : [],
    };
  },

  toJSON(message: NoonReportBunkerStatusv202005): unknown {
    const obj: any = {};
    if (message.sailingBunkerConsumption?.length) {
      obj.sailingBunkerConsumption = message.sailingBunkerConsumption.map((e) =>
        NoonReportSailingBunkerConsumptionv202005.toJSON(e)
      );
    }
    if (message.otherBunkerConsumption?.length) {
      obj.otherBunkerConsumption = message.otherBunkerConsumption.map((e) =>
        NoonReportOtherBunkerConsumptionv202005.toJSON(e)
      );
    }
    if (message.rob?.length) {
      obj.rob = message.rob.map((e) => NoonReportBunkerv202005.toJSON(e));
    }
    if (message.lastReceived?.length) {
      obj.lastReceived = message.lastReceived.map((e) => NoonReportLastReceivedv202005.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportBunkerStatusv202005>, I>>(base?: I): NoonReportBunkerStatusv202005 {
    return NoonReportBunkerStatusv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportBunkerStatusv202005>, I>>(
    object: I,
  ): NoonReportBunkerStatusv202005 {
    const message = createBaseNoonReportBunkerStatusv202005();
    message.sailingBunkerConsumption =
      object.sailingBunkerConsumption?.map((e) => NoonReportSailingBunkerConsumptionv202005.fromPartial(e)) || [];
    message.otherBunkerConsumption =
      object.otherBunkerConsumption?.map((e) => NoonReportOtherBunkerConsumptionv202005.fromPartial(e)) || [];
    message.rob = object.rob?.map((e) => NoonReportBunkerv202005.fromPartial(e)) || [];
    message.lastReceived = object.lastReceived?.map((e) => NoonReportLastReceivedv202005.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLubOilStatusv202005(): LubOilStatusv202005 {
  return {
    mainEngineCylinderOilConsumption: 0,
    mainEngineSystemOilConsumption: 0,
    auxiliarySystemOilConsumption: 0,
    mainEngineCylinderOilRob: 0,
    mainEngineSystemOilRob: 0,
    auxiliarySystemOilRob: 0,
    lastReceived: [],
  };
}

export const LubOilStatusv202005: MessageFns<LubOilStatusv202005> = {
  encode(message: LubOilStatusv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mainEngineCylinderOilConsumption !== 0) {
      writer.uint32(9).double(message.mainEngineCylinderOilConsumption);
    }
    if (message.mainEngineSystemOilConsumption !== 0) {
      writer.uint32(17).double(message.mainEngineSystemOilConsumption);
    }
    if (message.auxiliarySystemOilConsumption !== 0) {
      writer.uint32(25).double(message.auxiliarySystemOilConsumption);
    }
    if (message.mainEngineCylinderOilRob !== 0) {
      writer.uint32(33).double(message.mainEngineCylinderOilRob);
    }
    if (message.mainEngineSystemOilRob !== 0) {
      writer.uint32(41).double(message.mainEngineSystemOilRob);
    }
    if (message.auxiliarySystemOilRob !== 0) {
      writer.uint32(49).double(message.auxiliarySystemOilRob);
    }
    for (const v of message.lastReceived) {
      NoonReportLastReceivedv202005.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LubOilStatusv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLubOilStatusv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.mainEngineCylinderOilConsumption = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.mainEngineSystemOilConsumption = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.auxiliarySystemOilConsumption = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.mainEngineCylinderOilRob = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.mainEngineSystemOilRob = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.auxiliarySystemOilRob = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.lastReceived.push(NoonReportLastReceivedv202005.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LubOilStatusv202005 {
    return {
      mainEngineCylinderOilConsumption: isSet(object.mainEngineCylinderOilConsumption)
        ? globalThis.Number(object.mainEngineCylinderOilConsumption)
        : isSet(object.main_engine_cylinder_oil_consumption)
        ? globalThis.Number(object.main_engine_cylinder_oil_consumption)
        : 0,
      mainEngineSystemOilConsumption: isSet(object.mainEngineSystemOilConsumption)
        ? globalThis.Number(object.mainEngineSystemOilConsumption)
        : isSet(object.main_engine_system_oil_consumption)
        ? globalThis.Number(object.main_engine_system_oil_consumption)
        : 0,
      auxiliarySystemOilConsumption: isSet(object.auxiliarySystemOilConsumption)
        ? globalThis.Number(object.auxiliarySystemOilConsumption)
        : isSet(object.auxiliary_system_oil_consumption)
        ? globalThis.Number(object.auxiliary_system_oil_consumption)
        : 0,
      mainEngineCylinderOilRob: isSet(object.mainEngineCylinderOilRob)
        ? globalThis.Number(object.mainEngineCylinderOilRob)
        : isSet(object.main_engine_cylinder_oil_rob)
        ? globalThis.Number(object.main_engine_cylinder_oil_rob)
        : 0,
      mainEngineSystemOilRob: isSet(object.mainEngineSystemOilRob)
        ? globalThis.Number(object.mainEngineSystemOilRob)
        : isSet(object.main_engine_system_oil_rob)
        ? globalThis.Number(object.main_engine_system_oil_rob)
        : 0,
      auxiliarySystemOilRob: isSet(object.auxiliarySystemOilRob)
        ? globalThis.Number(object.auxiliarySystemOilRob)
        : isSet(object.auxiliary_system_oil_rob)
        ? globalThis.Number(object.auxiliary_system_oil_rob)
        : 0,
      lastReceived: globalThis.Array.isArray(object?.lastReceived)
        ? object.lastReceived.map((e: any) => NoonReportLastReceivedv202005.fromJSON(e))
        : globalThis.Array.isArray(object?.last_received)
        ? object.last_received.map((e: any) => NoonReportLastReceivedv202005.fromJSON(e))
        : [],
    };
  },

  toJSON(message: LubOilStatusv202005): unknown {
    const obj: any = {};
    if (message.mainEngineCylinderOilConsumption !== 0) {
      obj.mainEngineCylinderOilConsumption = message.mainEngineCylinderOilConsumption;
    }
    if (message.mainEngineSystemOilConsumption !== 0) {
      obj.mainEngineSystemOilConsumption = message.mainEngineSystemOilConsumption;
    }
    if (message.auxiliarySystemOilConsumption !== 0) {
      obj.auxiliarySystemOilConsumption = message.auxiliarySystemOilConsumption;
    }
    if (message.mainEngineCylinderOilRob !== 0) {
      obj.mainEngineCylinderOilRob = message.mainEngineCylinderOilRob;
    }
    if (message.mainEngineSystemOilRob !== 0) {
      obj.mainEngineSystemOilRob = message.mainEngineSystemOilRob;
    }
    if (message.auxiliarySystemOilRob !== 0) {
      obj.auxiliarySystemOilRob = message.auxiliarySystemOilRob;
    }
    if (message.lastReceived?.length) {
      obj.lastReceived = message.lastReceived.map((e) => NoonReportLastReceivedv202005.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LubOilStatusv202005>, I>>(base?: I): LubOilStatusv202005 {
    return LubOilStatusv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LubOilStatusv202005>, I>>(object: I): LubOilStatusv202005 {
    const message = createBaseLubOilStatusv202005();
    message.mainEngineCylinderOilConsumption = object.mainEngineCylinderOilConsumption ?? 0;
    message.mainEngineSystemOilConsumption = object.mainEngineSystemOilConsumption ?? 0;
    message.auxiliarySystemOilConsumption = object.auxiliarySystemOilConsumption ?? 0;
    message.mainEngineCylinderOilRob = object.mainEngineCylinderOilRob ?? 0;
    message.mainEngineSystemOilRob = object.mainEngineSystemOilRob ?? 0;
    message.auxiliarySystemOilRob = object.auxiliarySystemOilRob ?? 0;
    message.lastReceived = object.lastReceived?.map((e) => NoonReportLastReceivedv202005.fromPartial(e)) || [];
    return message;
  },
};

function createBaseFreshWaterStatusv202005(): FreshWaterStatusv202005 {
  return { rob: 0, consumption: 0, generated: 0, lastReceived: undefined };
}

export const FreshWaterStatusv202005: MessageFns<FreshWaterStatusv202005> = {
  encode(message: FreshWaterStatusv202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rob !== 0) {
      writer.uint32(9).double(message.rob);
    }
    if (message.consumption !== 0) {
      writer.uint32(17).double(message.consumption);
    }
    if (message.generated !== 0) {
      writer.uint32(25).double(message.generated);
    }
    if (message.lastReceived !== undefined) {
      NoonReportLastReceivedv202005.encode(message.lastReceived, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FreshWaterStatusv202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFreshWaterStatusv202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.rob = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.consumption = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.generated = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.lastReceived = NoonReportLastReceivedv202005.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FreshWaterStatusv202005 {
    return {
      rob: isSet(object.rob) ? globalThis.Number(object.rob) : 0,
      consumption: isSet(object.consumption) ? globalThis.Number(object.consumption) : 0,
      generated: isSet(object.generated) ? globalThis.Number(object.generated) : 0,
      lastReceived: isSet(object.lastReceived)
        ? NoonReportLastReceivedv202005.fromJSON(object.lastReceived)
        : isSet(object.last_received)
        ? NoonReportLastReceivedv202005.fromJSON(object.last_received)
        : undefined,
    };
  },

  toJSON(message: FreshWaterStatusv202005): unknown {
    const obj: any = {};
    if (message.rob !== 0) {
      obj.rob = message.rob;
    }
    if (message.consumption !== 0) {
      obj.consumption = message.consumption;
    }
    if (message.generated !== 0) {
      obj.generated = message.generated;
    }
    if (message.lastReceived !== undefined) {
      obj.lastReceived = NoonReportLastReceivedv202005.toJSON(message.lastReceived);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FreshWaterStatusv202005>, I>>(base?: I): FreshWaterStatusv202005 {
    return FreshWaterStatusv202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FreshWaterStatusv202005>, I>>(object: I): FreshWaterStatusv202005 {
    const message = createBaseFreshWaterStatusv202005();
    message.rob = object.rob ?? 0;
    message.consumption = object.consumption ?? 0;
    message.generated = object.generated ?? 0;
    message.lastReceived = (object.lastReceived !== undefined && object.lastReceived !== null)
      ? NoonReportLastReceivedv202005.fromPartial(object.lastReceived)
      : undefined;
    return message;
  },
};

function createBaseNoonReportV202005(): NoonReportV202005 {
  return {
    vesselName: "",
    vesselImo: "",
    date: undefined,
    reportType: "",
    voyageDetails: undefined,
    master: "",
    isDeleted: undefined,
    position: undefined,
    speed: undefined,
    condition: undefined,
    tanksCondition: [],
    noonReportBunkerStatus: undefined,
    lubOilStatus: undefined,
    freshWaterStatus: undefined,
    fileId: "",
    comments: "",
  };
}

export const NoonReportV202005: MessageFns<NoonReportV202005> = {
  encode(message: NoonReportV202005, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vesselName !== "") {
      writer.uint32(10).string(message.vesselName);
    }
    if (message.vesselImo !== "") {
      writer.uint32(18).string(message.vesselImo);
    }
    if (message.date !== undefined) {
      NoonReportDatev202005.encode(message.date, writer.uint32(26).fork()).join();
    }
    if (message.reportType !== "") {
      writer.uint32(34).string(message.reportType);
    }
    if (message.voyageDetails !== undefined) {
      NoonReportVoyageDetailsv202005.encode(message.voyageDetails, writer.uint32(42).fork()).join();
    }
    if (message.master !== "") {
      writer.uint32(50).string(message.master);
    }
    if (message.isDeleted !== undefined) {
      writer.uint32(56).bool(message.isDeleted);
    }
    if (message.position !== undefined) {
      NoonReportPositionv202005.encode(message.position, writer.uint32(66).fork()).join();
    }
    if (message.speed !== undefined) {
      NoonReportSpeedv202005.encode(message.speed, writer.uint32(74).fork()).join();
    }
    if (message.condition !== undefined) {
      NoonReportConditionv202005.encode(message.condition, writer.uint32(82).fork()).join();
    }
    for (const v of message.tanksCondition) {
      NoonReportTankConditionv202005.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.noonReportBunkerStatus !== undefined) {
      NoonReportBunkerStatusv202005.encode(message.noonReportBunkerStatus, writer.uint32(98).fork()).join();
    }
    if (message.lubOilStatus !== undefined) {
      LubOilStatusv202005.encode(message.lubOilStatus, writer.uint32(106).fork()).join();
    }
    if (message.freshWaterStatus !== undefined) {
      FreshWaterStatusv202005.encode(message.freshWaterStatus, writer.uint32(114).fork()).join();
    }
    if (message.fileId !== "") {
      writer.uint32(122).string(message.fileId);
    }
    if (message.comments !== "") {
      writer.uint32(130).string(message.comments);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportV202005 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportV202005();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vesselName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.vesselImo = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.date = NoonReportDatev202005.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.reportType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.voyageDetails = NoonReportVoyageDetailsv202005.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.master = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isDeleted = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.position = NoonReportPositionv202005.decode(reader, reader.uint32());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.speed = NoonReportSpeedv202005.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.condition = NoonReportConditionv202005.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.tanksCondition.push(NoonReportTankConditionv202005.decode(reader, reader.uint32()));
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.noonReportBunkerStatus = NoonReportBunkerStatusv202005.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.lubOilStatus = LubOilStatusv202005.decode(reader, reader.uint32());
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.freshWaterStatus = FreshWaterStatusv202005.decode(reader, reader.uint32());
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportV202005 {
    return {
      vesselName: isSet(object.vesselName)
        ? globalThis.String(object.vesselName)
        : isSet(object.vessel_name)
        ? globalThis.String(object.vessel_name)
        : "",
      vesselImo: isSet(object.vesselImo)
        ? globalThis.String(object.vesselImo)
        : isSet(object.vessel_imo)
        ? globalThis.String(object.vessel_imo)
        : "",
      date: isSet(object.date) ? NoonReportDatev202005.fromJSON(object.date) : undefined,
      reportType: isSet(object.reportType)
        ? globalThis.String(object.reportType)
        : isSet(object.report_type)
        ? globalThis.String(object.report_type)
        : "",
      voyageDetails: isSet(object.voyageDetails)
        ? NoonReportVoyageDetailsv202005.fromJSON(object.voyageDetails)
        : isSet(object.voyage_details)
        ? NoonReportVoyageDetailsv202005.fromJSON(object.voyage_details)
        : undefined,
      master: isSet(object.master) ? globalThis.String(object.master) : "",
      isDeleted: isSet(object.isDeleted)
        ? globalThis.Boolean(object.isDeleted)
        : isSet(object.is_deleted)
        ? globalThis.Boolean(object.is_deleted)
        : undefined,
      position: isSet(object.position) ? NoonReportPositionv202005.fromJSON(object.position) : undefined,
      speed: isSet(object.speed) ? NoonReportSpeedv202005.fromJSON(object.speed) : undefined,
      condition: isSet(object.condition) ? NoonReportConditionv202005.fromJSON(object.condition) : undefined,
      tanksCondition: globalThis.Array.isArray(object?.tanksCondition)
        ? object.tanksCondition.map((e: any) => NoonReportTankConditionv202005.fromJSON(e))
        : globalThis.Array.isArray(object?.tanks_condition)
        ? object.tanks_condition.map((e: any) => NoonReportTankConditionv202005.fromJSON(e))
        : [],
      noonReportBunkerStatus: isSet(object.noonReportBunkerStatus)
        ? NoonReportBunkerStatusv202005.fromJSON(object.noonReportBunkerStatus)
        : isSet(object.noon_report_bunker_status)
        ? NoonReportBunkerStatusv202005.fromJSON(object.noon_report_bunker_status)
        : undefined,
      lubOilStatus: isSet(object.lubOilStatus)
        ? LubOilStatusv202005.fromJSON(object.lubOilStatus)
        : isSet(object.lub_oil_status)
        ? LubOilStatusv202005.fromJSON(object.lub_oil_status)
        : undefined,
      freshWaterStatus: isSet(object.freshWaterStatus)
        ? FreshWaterStatusv202005.fromJSON(object.freshWaterStatus)
        : isSet(object.fresh_water_status)
        ? FreshWaterStatusv202005.fromJSON(object.fresh_water_status)
        : undefined,
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
    };
  },

  toJSON(message: NoonReportV202005): unknown {
    const obj: any = {};
    if (message.vesselName !== "") {
      obj.vesselName = message.vesselName;
    }
    if (message.vesselImo !== "") {
      obj.vesselImo = message.vesselImo;
    }
    if (message.date !== undefined) {
      obj.date = NoonReportDatev202005.toJSON(message.date);
    }
    if (message.reportType !== "") {
      obj.reportType = message.reportType;
    }
    if (message.voyageDetails !== undefined) {
      obj.voyageDetails = NoonReportVoyageDetailsv202005.toJSON(message.voyageDetails);
    }
    if (message.master !== "") {
      obj.master = message.master;
    }
    if (message.isDeleted !== undefined) {
      obj.isDeleted = message.isDeleted;
    }
    if (message.position !== undefined) {
      obj.position = NoonReportPositionv202005.toJSON(message.position);
    }
    if (message.speed !== undefined) {
      obj.speed = NoonReportSpeedv202005.toJSON(message.speed);
    }
    if (message.condition !== undefined) {
      obj.condition = NoonReportConditionv202005.toJSON(message.condition);
    }
    if (message.tanksCondition?.length) {
      obj.tanksCondition = message.tanksCondition.map((e) => NoonReportTankConditionv202005.toJSON(e));
    }
    if (message.noonReportBunkerStatus !== undefined) {
      obj.noonReportBunkerStatus = NoonReportBunkerStatusv202005.toJSON(message.noonReportBunkerStatus);
    }
    if (message.lubOilStatus !== undefined) {
      obj.lubOilStatus = LubOilStatusv202005.toJSON(message.lubOilStatus);
    }
    if (message.freshWaterStatus !== undefined) {
      obj.freshWaterStatus = FreshWaterStatusv202005.toJSON(message.freshWaterStatus);
    }
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportV202005>, I>>(base?: I): NoonReportV202005 {
    return NoonReportV202005.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportV202005>, I>>(object: I): NoonReportV202005 {
    const message = createBaseNoonReportV202005();
    message.vesselName = object.vesselName ?? "";
    message.vesselImo = object.vesselImo ?? "";
    message.date = (object.date !== undefined && object.date !== null)
      ? NoonReportDatev202005.fromPartial(object.date)
      : undefined;
    message.reportType = object.reportType ?? "";
    message.voyageDetails = (object.voyageDetails !== undefined && object.voyageDetails !== null)
      ? NoonReportVoyageDetailsv202005.fromPartial(object.voyageDetails)
      : undefined;
    message.master = object.master ?? "";
    message.isDeleted = object.isDeleted ?? undefined;
    message.position = (object.position !== undefined && object.position !== null)
      ? NoonReportPositionv202005.fromPartial(object.position)
      : undefined;
    message.speed = (object.speed !== undefined && object.speed !== null)
      ? NoonReportSpeedv202005.fromPartial(object.speed)
      : undefined;
    message.condition = (object.condition !== undefined && object.condition !== null)
      ? NoonReportConditionv202005.fromPartial(object.condition)
      : undefined;
    message.tanksCondition = object.tanksCondition?.map((e) => NoonReportTankConditionv202005.fromPartial(e)) || [];
    message.noonReportBunkerStatus =
      (object.noonReportBunkerStatus !== undefined && object.noonReportBunkerStatus !== null)
        ? NoonReportBunkerStatusv202005.fromPartial(object.noonReportBunkerStatus)
        : undefined;
    message.lubOilStatus = (object.lubOilStatus !== undefined && object.lubOilStatus !== null)
      ? LubOilStatusv202005.fromPartial(object.lubOilStatus)
      : undefined;
    message.freshWaterStatus = (object.freshWaterStatus !== undefined && object.freshWaterStatus !== null)
      ? FreshWaterStatusv202005.fromPartial(object.freshWaterStatus)
      : undefined;
    message.fileId = object.fileId ?? "";
    message.comments = object.comments ?? "";
    return message;
  },
};

function createBaseNoonReportV202005Request(): NoonReportV202005Request {
  return { startTimestamp: 0, endTimestamp: 0 };
}

export const NoonReportV202005Request: MessageFns<NoonReportV202005Request> = {
  encode(message: NoonReportV202005Request, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.startTimestamp !== 0) {
      writer.uint32(8).int64(message.startTimestamp);
    }
    if (message.endTimestamp !== 0) {
      writer.uint32(16).int64(message.endTimestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportV202005Request {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportV202005Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.startTimestamp = longToNumber(reader.int64());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.endTimestamp = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportV202005Request {
    return {
      startTimestamp: isSet(object.startTimestamp)
        ? globalThis.Number(object.startTimestamp)
        : isSet(object.start_timestamp)
        ? globalThis.Number(object.start_timestamp)
        : 0,
      endTimestamp: isSet(object.endTimestamp)
        ? globalThis.Number(object.endTimestamp)
        : isSet(object.end_timestamp)
        ? globalThis.Number(object.end_timestamp)
        : 0,
    };
  },

  toJSON(message: NoonReportV202005Request): unknown {
    const obj: any = {};
    if (message.startTimestamp !== 0) {
      obj.startTimestamp = Math.round(message.startTimestamp);
    }
    if (message.endTimestamp !== 0) {
      obj.endTimestamp = Math.round(message.endTimestamp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportV202005Request>, I>>(base?: I): NoonReportV202005Request {
    return NoonReportV202005Request.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportV202005Request>, I>>(object: I): NoonReportV202005Request {
    const message = createBaseNoonReportV202005Request();
    message.startTimestamp = object.startTimestamp ?? 0;
    message.endTimestamp = object.endTimestamp ?? 0;
    return message;
  },
};

function createBaseNoonReportV202005Response(): NoonReportV202005Response {
  return { excelFile: new Uint8Array(0), fileName: "" };
}

export const NoonReportV202005Response: MessageFns<NoonReportV202005Response> = {
  encode(message: NoonReportV202005Response, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.excelFile.length !== 0) {
      writer.uint32(10).bytes(message.excelFile);
    }
    if (message.fileName !== "") {
      writer.uint32(18).string(message.fileName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NoonReportV202005Response {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNoonReportV202005Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.excelFile = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NoonReportV202005Response {
    return {
      excelFile: isSet(object.excelFile)
        ? bytesFromBase64(object.excelFile)
        : isSet(object.excel_file)
        ? bytesFromBase64(object.excel_file)
        : new Uint8Array(0),
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : "",
    };
  },

  toJSON(message: NoonReportV202005Response): unknown {
    const obj: any = {};
    if (message.excelFile.length !== 0) {
      obj.excelFile = base64FromBytes(message.excelFile);
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NoonReportV202005Response>, I>>(base?: I): NoonReportV202005Response {
    return NoonReportV202005Response.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NoonReportV202005Response>, I>>(object: I): NoonReportV202005Response {
    const message = createBaseNoonReportV202005Response();
    message.excelFile = object.excelFile ?? new Uint8Array(0);
    message.fileName = object.fileName ?? "";
    return message;
  },
};

function createBaseLatestReports(): LatestReports {
  return { vessel: undefined, voyage: undefined, noonReportV2020: undefined };
}

export const LatestReports: MessageFns<LatestReports> = {
  encode(message: LatestReports, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.vessel !== undefined) {
      Vessel.encode(message.vessel, writer.uint32(10).fork()).join();
    }
    if (message.voyage !== undefined) {
      Voyage.encode(message.voyage, writer.uint32(18).fork()).join();
    }
    if (message.noonReportV2020 !== undefined) {
      NoonReportV202005.encode(message.noonReportV2020, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LatestReports {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLatestReports();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.vessel = Vessel.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.voyage = Voyage.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.noonReportV2020 = NoonReportV202005.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LatestReports {
    return {
      vessel: isSet(object.vessel) ? Vessel.fromJSON(object.vessel) : undefined,
      voyage: isSet(object.voyage) ? Voyage.fromJSON(object.voyage) : undefined,
      noonReportV2020: isSet(object.noonReportV2020)
        ? NoonReportV202005.fromJSON(object.noonReportV2020)
        : isSet(object.noon_report_v2020)
        ? NoonReportV202005.fromJSON(object.noon_report_v2020)
        : undefined,
    };
  },

  toJSON(message: LatestReports): unknown {
    const obj: any = {};
    if (message.vessel !== undefined) {
      obj.vessel = Vessel.toJSON(message.vessel);
    }
    if (message.voyage !== undefined) {
      obj.voyage = Voyage.toJSON(message.voyage);
    }
    if (message.noonReportV2020 !== undefined) {
      obj.noonReportV2020 = NoonReportV202005.toJSON(message.noonReportV2020);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LatestReports>, I>>(base?: I): LatestReports {
    return LatestReports.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LatestReports>, I>>(object: I): LatestReports {
    const message = createBaseLatestReports();
    message.vessel = (object.vessel !== undefined && object.vessel !== null)
      ? Vessel.fromPartial(object.vessel)
      : undefined;
    message.voyage = (object.voyage !== undefined && object.voyage !== null)
      ? Voyage.fromPartial(object.voyage)
      : undefined;
    message.noonReportV2020 = (object.noonReportV2020 !== undefined && object.noonReportV2020 !== null)
      ? NoonReportV202005.fromPartial(object.noonReportV2020)
      : undefined;
    return message;
  },
};

function createBaseGetManagementResponse(): GetManagementResponse {
  return { reports: [] };
}

export const GetManagementResponse: MessageFns<GetManagementResponse> = {
  encode(message: GetManagementResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.reports) {
      LatestReports.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetManagementResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetManagementResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reports.push(LatestReports.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetManagementResponse {
    return {
      reports: globalThis.Array.isArray(object?.reports)
        ? object.reports.map((e: any) => LatestReports.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetManagementResponse): unknown {
    const obj: any = {};
    if (message.reports?.length) {
      obj.reports = message.reports.map((e) => LatestReports.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetManagementResponse>, I>>(base?: I): GetManagementResponse {
    return GetManagementResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetManagementResponse>, I>>(object: I): GetManagementResponse {
    const message = createBaseGetManagementResponse();
    message.reports = object.reports?.map((e) => LatestReports.fromPartial(e)) || [];
    return message;
  },
};

export interface NoonReportService {
  getNoonReportsV202005Between(
    request: DeepPartial<DateRangeRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetNoonReportV202005Response>;
  getNoonReportsV202205Between(
    request: DeepPartial<DateRangeRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetVesselReportV202205Response>;
  getNoonReportsV202005Excel(
    request: DeepPartial<NoonReportV202005Request>,
    metadata?: grpc.Metadata,
  ): Promise<NoonReportV202005Response>;
  getLatestNoonReportsV202005(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetNoonReportV202005Response>;
  getLatestManagementReport(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetManagementResponse>;
  updateNoonReportV202005(
    request: DeepPartial<UpdateNoonReportV202005Request>,
    metadata?: grpc.Metadata,
  ): Promise<NoonReportV202005>;
  updateNoonReportV202205(request: DeepPartial<VesselReportV202205>, metadata?: grpc.Metadata): Promise<EmptyResponse>;
}

export class NoonReportServiceClientImpl implements NoonReportService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.getNoonReportsV202005Between = this.getNoonReportsV202005Between.bind(this);
    this.getNoonReportsV202205Between = this.getNoonReportsV202205Between.bind(this);
    this.getNoonReportsV202005Excel = this.getNoonReportsV202005Excel.bind(this);
    this.getLatestNoonReportsV202005 = this.getLatestNoonReportsV202005.bind(this);
    this.getLatestManagementReport = this.getLatestManagementReport.bind(this);
    this.updateNoonReportV202005 = this.updateNoonReportV202005.bind(this);
    this.updateNoonReportV202205 = this.updateNoonReportV202205.bind(this);
  }

  getNoonReportsV202005Between(
    request: DeepPartial<DateRangeRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetNoonReportV202005Response> {
    return this.rpc.unary(
      NoonReportServiceGetNoonReportsV202005BetweenDesc,
      DateRangeRequest.fromPartial(request),
      metadata,
    );
  }

  getNoonReportsV202205Between(
    request: DeepPartial<DateRangeRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetVesselReportV202205Response> {
    return this.rpc.unary(
      NoonReportServiceGetNoonReportsV202205BetweenDesc,
      DateRangeRequest.fromPartial(request),
      metadata,
    );
  }

  getNoonReportsV202005Excel(
    request: DeepPartial<NoonReportV202005Request>,
    metadata?: grpc.Metadata,
  ): Promise<NoonReportV202005Response> {
    return this.rpc.unary(
      NoonReportServiceGetNoonReportsV202005ExcelDesc,
      NoonReportV202005Request.fromPartial(request),
      metadata,
    );
  }

  getLatestNoonReportsV202005(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetNoonReportV202005Response> {
    return this.rpc.unary(
      NoonReportServiceGetLatestNoonReportsV202005Desc,
      EmptyRequest.fromPartial(request),
      metadata,
    );
  }

  getLatestManagementReport(
    request: DeepPartial<EmptyRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetManagementResponse> {
    return this.rpc.unary(NoonReportServiceGetLatestManagementReportDesc, EmptyRequest.fromPartial(request), metadata);
  }

  updateNoonReportV202005(
    request: DeepPartial<UpdateNoonReportV202005Request>,
    metadata?: grpc.Metadata,
  ): Promise<NoonReportV202005> {
    return this.rpc.unary(
      NoonReportServiceUpdateNoonReportV202005Desc,
      UpdateNoonReportV202005Request.fromPartial(request),
      metadata,
    );
  }

  updateNoonReportV202205(request: DeepPartial<VesselReportV202205>, metadata?: grpc.Metadata): Promise<EmptyResponse> {
    return this.rpc.unary(
      NoonReportServiceUpdateNoonReportV202205Desc,
      VesselReportV202205.fromPartial(request),
      metadata,
    );
  }
}

export const NoonReportServiceDesc = { serviceName: "services.transportation.reports.NoonReportService" };

export const NoonReportServiceGetNoonReportsV202005BetweenDesc: UnaryMethodDefinitionish = {
  methodName: "GetNoonReportsV202005Between",
  service: NoonReportServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DateRangeRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetNoonReportV202005Response.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const NoonReportServiceGetNoonReportsV202205BetweenDesc: UnaryMethodDefinitionish = {
  methodName: "GetNoonReportsV202205Between",
  service: NoonReportServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return DateRangeRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetVesselReportV202205Response.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const NoonReportServiceGetNoonReportsV202005ExcelDesc: UnaryMethodDefinitionish = {
  methodName: "GetNoonReportsV202005Excel",
  service: NoonReportServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return NoonReportV202005Request.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = NoonReportV202005Response.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const NoonReportServiceGetLatestNoonReportsV202005Desc: UnaryMethodDefinitionish = {
  methodName: "GetLatestNoonReportsV202005",
  service: NoonReportServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetNoonReportV202005Response.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const NoonReportServiceGetLatestManagementReportDesc: UnaryMethodDefinitionish = {
  methodName: "GetLatestManagementReport",
  service: NoonReportServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetManagementResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const NoonReportServiceUpdateNoonReportV202005Desc: UnaryMethodDefinitionish = {
  methodName: "UpdateNoonReportV202005",
  service: NoonReportServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateNoonReportV202005Request.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = NoonReportV202005.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const NoonReportServiceUpdateNoonReportV202205Desc: UnaryMethodDefinitionish = {
  methodName: "UpdateNoonReportV202205",
  service: NoonReportServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return VesselReportV202205.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = EmptyResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
